import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** 
 * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
 */
  DateTime: any,
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any,
  /** 
 * A date string, such as 2007-12-03, compliant with the `full-date` format
   * outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for
   * representation of dates and times using the Gregorian calendar.
 */
  Date: any,
  /** The `Upload` scalar type represents a file upload. */
  Upload: any,
  /** The `Long` scalar type represents 52-bit integers */
  Long: any,
  /** A time string with format: HH:mm:ss.SSS */
  Time: any,
};


export type ActualFault = {
   __typename?: 'ActualFault',
  fault?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type ActualFaultInput = {
  fault?: Maybe<Scalars['String']>,
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type CiInformation = {
   __typename?: 'CiInformation',
  ciName?: Maybe<Scalars['String']>,
  serialNum?: Maybe<Scalars['String']>,
  ciLocation?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type CiInformationInput = {
  ciName?: Maybe<Scalars['String']>,
  serialNum?: Maybe<Scalars['String']>,
  ciLocation?: Maybe<Scalars['String']>,
};

export type Client = {
   __typename?: 'Client',
  name?: Maybe<Scalars['String']>,
  vatNumber?: Maybe<Scalars['String']>,
  contractors?: Maybe<Array<Maybe<UsersPermissionsUser>>>,
  tickets?: Maybe<Array<Maybe<Ticket>>>,
  notifications?: Maybe<Array<Maybe<Notifications>>>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};


export type ClientContractorsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type ClientTicketsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type ClientNotificationsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};

export type ClientInput = {
  name?: Maybe<Scalars['String']>,
  contractors?: Maybe<Array<Maybe<Scalars['ID']>>>,
  vatNumber?: Maybe<Scalars['String']>,
  tickets?: Maybe<Array<Maybe<Scalars['ID']>>>,
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type ComponentItemsItemInput = {
  item?: Maybe<Scalars['ID']>,
  unitPrice?: Maybe<Scalars['Float']>,
  quantity?: Maybe<Scalars['Float']>,
  totalPrice?: Maybe<Scalars['Float']>,
  description?: Maybe<Scalars['String']>,
  itemType?: Maybe<Scalars['ID']>,
};

export type ComponentItemsItems = {
   __typename?: 'ComponentItemsItems',
  item?: Maybe<Item>,
  unitPrice?: Maybe<Scalars['Float']>,
  quantity?: Maybe<Scalars['Float']>,
  totalPrice?: Maybe<Scalars['Float']>,
  description?: Maybe<Scalars['String']>,
  itemType?: Maybe<ItemType>,
  id: Scalars['ID'],
};

export type Configuration = {
   __typename?: 'Configuration',
  showWarranty?: Maybe<Scalars['Boolean']>,
  showQuoteBuilder?: Maybe<Scalars['Boolean']>,
  showDocuments?: Maybe<Scalars['Boolean']>,
  showVendorInfo?: Maybe<Scalars['Boolean']>,
  showCiInfo?: Maybe<Scalars['Boolean']>,
  showClosingInfo?: Maybe<Scalars['Boolean']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type ConfigurationInput = {
  showWarranty?: Maybe<Scalars['Boolean']>,
  showQuoteBuilder?: Maybe<Scalars['Boolean']>,
  showDocuments?: Maybe<Scalars['Boolean']>,
  showVendorInfo?: Maybe<Scalars['Boolean']>,
  showCiInfo?: Maybe<Scalars['Boolean']>,
  showClosingInfo?: Maybe<Scalars['Boolean']>,
};

export type CreateActualFaultInput = {
  data?: Maybe<ActualFaultInput>,
};

export type CreateActualFaultPayload = {
   __typename?: 'createActualFaultPayload',
  actualFault?: Maybe<ActualFault>,
};

export type CreateCiInformationInput = {
  data?: Maybe<CiInformationInput>,
};

export type CreateCiInformationPayload = {
   __typename?: 'createCiInformationPayload',
  ciInformation?: Maybe<CiInformation>,
};

export type CreateClientInput = {
  data?: Maybe<ClientInput>,
};

export type CreateClientPayload = {
   __typename?: 'createClientPayload',
  client?: Maybe<Client>,
};

export type CreateConfigurationInput = {
  data?: Maybe<ConfigurationInput>,
};

export type CreateConfigurationPayload = {
   __typename?: 'createConfigurationPayload',
  configuration?: Maybe<Configuration>,
};

export type CreateDocumentInput = {
  data?: Maybe<DocumentInput>,
};

export type CreateDocumentPayload = {
   __typename?: 'createDocumentPayload',
  document?: Maybe<Document>,
};

export type CreateItemInput = {
  data?: Maybe<ItemInput>,
};

export type CreateItemPayload = {
   __typename?: 'createItemPayload',
  item?: Maybe<Item>,
};

export type CreateItemTypeInput = {
  data?: Maybe<ItemTypeInput>,
};

export type CreateItemTypePayload = {
   __typename?: 'createItemTypePayload',
  itemType?: Maybe<ItemType>,
};

export type CreateLocationInput = {
  data?: Maybe<LocationInput>,
};

export type CreateLocationPayload = {
   __typename?: 'createLocationPayload',
  location?: Maybe<Location>,
};

export type CreateMessageInput = {
  data?: Maybe<MessageInput>,
};

export type CreateMessagePayload = {
   __typename?: 'createMessagePayload',
  message?: Maybe<Message>,
};

export type CreateNotificationInput = {
  data?: Maybe<NotificationInput>,
};

export type CreateNotificationPayload = {
   __typename?: 'createNotificationPayload',
  notification?: Maybe<Notifications>,
};

export type CreateQuoteInput = {
  data?: Maybe<QuoteInput>,
};

export type CreateQuotePayload = {
   __typename?: 'createQuotePayload',
  quote?: Maybe<Quote>,
};

export type CreateResolutionCodeInput = {
  data?: Maybe<ResolutionCodeInput>,
};

export type CreateResolutionCodePayload = {
   __typename?: 'createResolutionCodePayload',
  resolutionCode?: Maybe<ResolutionCode>,
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>,
};

export type CreateRolePayload = {
   __typename?: 'createRolePayload',
  role?: Maybe<UsersPermissionsRole>,
};

export type CreateSignalRegistryInput = {
  data?: Maybe<SignalRegistryInput>,
};

export type CreateSignalRegistryPayload = {
   __typename?: 'createSignalRegistryPayload',
  signalRegistry?: Maybe<SignalRegistry>,
};

export type CreateStatusInput = {
  data?: Maybe<StatusInput>,
};

export type CreateStatusPayload = {
   __typename?: 'createStatusPayload',
  status?: Maybe<Status>,
};

export type CreateSubFaultInput = {
  data?: Maybe<SubFaultInput>,
};

export type CreateSubFaultPayload = {
   __typename?: 'createSubFaultPayload',
  subFault?: Maybe<SubFault>,
};

export type CreateTicketInput = {
  data?: Maybe<TicketInput>,
};

export type CreateTicketPayload = {
   __typename?: 'createTicketPayload',
  ticket?: Maybe<Ticket>,
};

export type CreateUserInput = {
  data?: Maybe<UserInput>,
};

export type CreateUserPayload = {
   __typename?: 'createUserPayload',
  user?: Maybe<UsersPermissionsUser>,
};

export type CreateVendorInformationInput = {
  data?: Maybe<VendorInformationInput>,
};

export type CreateVendorInformationPayload = {
   __typename?: 'createVendorInformationPayload',
  vendorInformation?: Maybe<VendorInformation>,
};



export type DeleteActualFaultInput = {
  where?: Maybe<InputId>,
};

export type DeleteActualFaultPayload = {
   __typename?: 'deleteActualFaultPayload',
  actualFault?: Maybe<ActualFault>,
};

export type DeleteCiInformationInput = {
  where?: Maybe<InputId>,
};

export type DeleteCiInformationPayload = {
   __typename?: 'deleteCiInformationPayload',
  ciInformation?: Maybe<CiInformation>,
};

export type DeleteClientInput = {
  where?: Maybe<InputId>,
};

export type DeleteClientPayload = {
   __typename?: 'deleteClientPayload',
  client?: Maybe<Client>,
};

export type DeleteConfigurationInput = {
  where?: Maybe<InputId>,
};

export type DeleteConfigurationPayload = {
   __typename?: 'deleteConfigurationPayload',
  configuration?: Maybe<Configuration>,
};

export type DeleteDocumentInput = {
  where?: Maybe<InputId>,
};

export type DeleteDocumentPayload = {
   __typename?: 'deleteDocumentPayload',
  document?: Maybe<Document>,
};

export type DeleteItemInput = {
  where?: Maybe<InputId>,
};

export type DeleteItemPayload = {
   __typename?: 'deleteItemPayload',
  item?: Maybe<Item>,
};

export type DeleteItemTypeInput = {
  where?: Maybe<InputId>,
};

export type DeleteItemTypePayload = {
   __typename?: 'deleteItemTypePayload',
  itemType?: Maybe<ItemType>,
};

export type DeleteLocationInput = {
  where?: Maybe<InputId>,
};

export type DeleteLocationPayload = {
   __typename?: 'deleteLocationPayload',
  location?: Maybe<Location>,
};

export type DeleteMessageInput = {
  where?: Maybe<InputId>,
};

export type DeleteMessagePayload = {
   __typename?: 'deleteMessagePayload',
  message?: Maybe<Message>,
};

export type DeleteNotificationInput = {
  where?: Maybe<InputId>,
};

export type DeleteNotificationPayload = {
   __typename?: 'deleteNotificationPayload',
  notification?: Maybe<Notifications>,
};

export type DeleteQuoteInput = {
  where?: Maybe<InputId>,
};

export type DeleteQuotePayload = {
   __typename?: 'deleteQuotePayload',
  quote?: Maybe<Quote>,
};

export type DeleteResolutionCodeInput = {
  where?: Maybe<InputId>,
};

export type DeleteResolutionCodePayload = {
   __typename?: 'deleteResolutionCodePayload',
  resolutionCode?: Maybe<ResolutionCode>,
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>,
};

export type DeleteRolePayload = {
   __typename?: 'deleteRolePayload',
  role?: Maybe<UsersPermissionsRole>,
};

export type DeleteSignalRegistryInput = {
  where?: Maybe<InputId>,
};

export type DeleteSignalRegistryPayload = {
   __typename?: 'deleteSignalRegistryPayload',
  signalRegistry?: Maybe<SignalRegistry>,
};

export type DeleteStatusInput = {
  where?: Maybe<InputId>,
};

export type DeleteStatusPayload = {
   __typename?: 'deleteStatusPayload',
  status?: Maybe<Status>,
};

export type DeleteSubFaultInput = {
  where?: Maybe<InputId>,
};

export type DeleteSubFaultPayload = {
   __typename?: 'deleteSubFaultPayload',
  subFault?: Maybe<SubFault>,
};

export type DeleteTicketInput = {
  where?: Maybe<InputId>,
};

export type DeleteTicketPayload = {
   __typename?: 'deleteTicketPayload',
  ticket?: Maybe<Ticket>,
};

export type DeleteUserInput = {
  where?: Maybe<InputId>,
};

export type DeleteUserPayload = {
   __typename?: 'deleteUserPayload',
  user?: Maybe<UsersPermissionsUser>,
};

export type DeleteVendorInformationInput = {
  where?: Maybe<InputId>,
};

export type DeleteVendorInformationPayload = {
   __typename?: 'deleteVendorInformationPayload',
  vendorInformation?: Maybe<VendorInformation>,
};

export type Document = {
   __typename?: 'Document',
  name?: Maybe<Scalars['String']>,
  file?: Maybe<UploadFile>,
  quote?: Maybe<Quote>,
  from?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type DocumentInput = {
  name?: Maybe<Scalars['String']>,
  file?: Maybe<Scalars['ID']>,
  quote?: Maybe<Scalars['ID']>,
  from?: Maybe<Scalars['String']>,
};

export type EditActualFaultInput = {
  fault?: Maybe<Scalars['String']>,
};

export type EditCiInformationInput = {
  ciName?: Maybe<Scalars['String']>,
  serialNum?: Maybe<Scalars['String']>,
  ciLocation?: Maybe<Scalars['String']>,
};

export type EditClientInput = {
  name?: Maybe<Scalars['String']>,
  contractors?: Maybe<Array<Maybe<Scalars['ID']>>>,
  vatNumber?: Maybe<Scalars['String']>,
  tickets?: Maybe<Array<Maybe<Scalars['ID']>>>,
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type EditComponentItemsItemInput = {
  id?: Maybe<Scalars['ID']>,
  item?: Maybe<Scalars['ID']>,
  unitPrice?: Maybe<Scalars['Float']>,
  quantity?: Maybe<Scalars['Float']>,
  totalPrice?: Maybe<Scalars['Float']>,
  description?: Maybe<Scalars['String']>,
  itemType?: Maybe<Scalars['ID']>,
};

export type EditConfigurationInput = {
  showWarranty?: Maybe<Scalars['Boolean']>,
  showQuoteBuilder?: Maybe<Scalars['Boolean']>,
  showDocuments?: Maybe<Scalars['Boolean']>,
  showVendorInfo?: Maybe<Scalars['Boolean']>,
  showCiInfo?: Maybe<Scalars['Boolean']>,
  showClosingInfo?: Maybe<Scalars['Boolean']>,
};

export type EditDocumentInput = {
  name?: Maybe<Scalars['String']>,
  file?: Maybe<Scalars['ID']>,
  quote?: Maybe<Scalars['ID']>,
  from?: Maybe<Scalars['String']>,
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  sha256?: Maybe<Scalars['String']>,
  ext?: Maybe<Scalars['String']>,
  mime?: Maybe<Scalars['String']>,
  size?: Maybe<Scalars['Float']>,
  url?: Maybe<Scalars['String']>,
  provider?: Maybe<Scalars['String']>,
  provider_metadata?: Maybe<Scalars['JSON']>,
  related?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type EditItemInput = {
  name?: Maybe<Scalars['String']>,
  recommendedUnitPrice?: Maybe<Scalars['Float']>,
  enabled?: Maybe<Scalars['Boolean']>,
  description?: Maybe<Scalars['String']>,
};

export type EditItemTypeInput = {
  description?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Scalars['String']>,
};

export type EditLocationInput = {
  name?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  googleMaps?: Maybe<Scalars['String']>,
};

export type EditMessageInput = {
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  ticket?: Maybe<Scalars['ID']>,
};

export type EditNotificationInput = {
  ticket?: Maybe<Scalars['ID']>,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  read?: Maybe<Scalars['Boolean']>,
  client?: Maybe<Scalars['ID']>,
};

export type EditQuoteInput = {
  expiryDate?: Maybe<Scalars['Date']>,
  status?: Maybe<Enum_Quote_Status>,
  termsAndConditions?: Maybe<Scalars['String']>,
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>,
  ticket?: Maybe<Scalars['ID']>,
  contractor?: Maybe<Scalars['ID']>,
  items?: Maybe<Array<Maybe<EditComponentItemsItemInput>>>,
};

export type EditResolutionCodeInput = {
  resCode?: Maybe<Scalars['String']>,
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>,
  users?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type EditSignalRegistryInput = {
  action?: Maybe<Scalars['String']>,
  entryId?: Maybe<Scalars['Int']>,
  processedState?: Maybe<Scalars['Int']>,
};

export type EditStatusInput = {
  name?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  content?: Maybe<Scalars['String']>,
  complete?: Maybe<Scalars['Boolean']>,
  uploadRequired?: Maybe<Scalars['Boolean']>,
};

export type EditSubFaultInput = {
  subFault?: Maybe<Scalars['String']>,
};

export type EditTicketInput = {
  location?: Maybe<Scalars['ID']>,
  summary?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['ID']>,
  warranty?: Maybe<Scalars['Boolean']>,
  client?: Maybe<Scalars['ID']>,
  ticketSummary?: Maybe<Scalars['String']>,
  warrantyStartDate?: Maybe<Scalars['Date']>,
  warrantyEndDate?: Maybe<Scalars['Date']>,
  quotes?: Maybe<Array<Maybe<Scalars['ID']>>>,
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>,
  messages?: Maybe<Array<Maybe<Scalars['ID']>>>,
  ticketNumber?: Maybe<Scalars['String']>,
  ticketSlaPriority?: Maybe<Scalars['String']>,
  quoteAmount?: Maybe<Scalars['Float']>,
  requestedBy?: Maybe<Scalars['String']>,
  vendor?: Maybe<Scalars['ID']>,
  ci?: Maybe<Scalars['ID']>,
  resolutionCode?: Maybe<Scalars['ID']>,
  actualFault?: Maybe<Scalars['ID']>,
  subFault?: Maybe<Scalars['ID']>,
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>,
  provider?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  resetPasswordToken?: Maybe<Scalars['String']>,
  confirmed?: Maybe<Scalars['Boolean']>,
  blocked?: Maybe<Scalars['Boolean']>,
  role?: Maybe<Scalars['ID']>,
  email?: Maybe<Scalars['String']>,
  contractorName?: Maybe<Scalars['String']>,
  quotes?: Maybe<Array<Maybe<Scalars['ID']>>>,
  client?: Maybe<Scalars['ID']>,
};

export type EditVendorInformationInput = {
  vendorRef?: Maybe<Scalars['String']>,
  dispatchDate?: Maybe<Scalars['DateTime']>,
  expectedArrival?: Maybe<Scalars['DateTime']>,
  actualArrival?: Maybe<Scalars['DateTime']>,
};

export enum Enum_Quote_Status {
  Pending = 'Pending',
  Sent = 'Sent',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Draft = 'Draft'
}

export type FileInput = {
  name: Scalars['String'],
  hash: Scalars['String'],
  sha256?: Maybe<Scalars['String']>,
  ext?: Maybe<Scalars['String']>,
  mime: Scalars['String'],
  size: Scalars['Float'],
  url: Scalars['String'],
  provider: Scalars['String'],
  provider_metadata?: Maybe<Scalars['JSON']>,
  related?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type InputId = {
  id: Scalars['ID'],
};

export type Item = {
   __typename?: 'Item',
  name?: Maybe<Scalars['String']>,
  recommendedUnitPrice?: Maybe<Scalars['Float']>,
  enabled?: Maybe<Scalars['Boolean']>,
  description?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type ItemInput = {
  name?: Maybe<Scalars['String']>,
  recommendedUnitPrice?: Maybe<Scalars['Float']>,
  enabled?: Maybe<Scalars['Boolean']>,
  description?: Maybe<Scalars['String']>,
};

export type ItemType = {
   __typename?: 'ItemType',
  description?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type ItemTypeInput = {
  description?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Scalars['String']>,
};


export type Location = {
   __typename?: 'Location',
  name?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  googleMaps?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type LocationInput = {
  name?: Maybe<Scalars['String']>,
  address?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  googleMaps?: Maybe<Scalars['String']>,
};


export type Message = {
   __typename?: 'Message',
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  ticket?: Maybe<Ticket>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type MessageInput = {
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  ticket?: Maybe<Scalars['ID']>,
};

export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | ActualFault | CreateActualFaultPayload | UpdateActualFaultPayload | DeleteActualFaultPayload | CiInformation | CreateCiInformationPayload | UpdateCiInformationPayload | DeleteCiInformationPayload | Client | CreateClientPayload | UpdateClientPayload | DeleteClientPayload | Configuration | CreateConfigurationPayload | UpdateConfigurationPayload | DeleteConfigurationPayload | Document | CreateDocumentPayload | UpdateDocumentPayload | DeleteDocumentPayload | ItemType | CreateItemTypePayload | UpdateItemTypePayload | DeleteItemTypePayload | Item | CreateItemPayload | UpdateItemPayload | DeleteItemPayload | Location | CreateLocationPayload | UpdateLocationPayload | DeleteLocationPayload | Message | CreateMessagePayload | UpdateMessagePayload | DeleteMessagePayload | Notifications | CreateNotificationPayload | UpdateNotificationPayload | DeleteNotificationPayload | Quote | CreateQuotePayload | UpdateQuotePayload | DeleteQuotePayload | ResolutionCode | CreateResolutionCodePayload | UpdateResolutionCodePayload | DeleteResolutionCodePayload | SignalRegistry | CreateSignalRegistryPayload | UpdateSignalRegistryPayload | DeleteSignalRegistryPayload | Status | CreateStatusPayload | UpdateStatusPayload | DeleteStatusPayload | SubFault | CreateSubFaultPayload | UpdateSubFaultPayload | DeleteSubFaultPayload | Ticket | CreateTicketPayload | UpdateTicketPayload | DeleteTicketPayload | VendorInformation | CreateVendorInformationPayload | UpdateVendorInformationPayload | DeleteVendorInformationPayload | UploadFile | UsersPermissionsPermission | UsersPermissionsRole | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | CreateUserPayload | UpdateUserPayload | DeleteUserPayload;

export type Mutation = {
   __typename?: 'Mutation',
  createActualFault?: Maybe<CreateActualFaultPayload>,
  updateActualFault?: Maybe<UpdateActualFaultPayload>,
  deleteActualFault?: Maybe<DeleteActualFaultPayload>,
  createCiInformation?: Maybe<CreateCiInformationPayload>,
  updateCiInformation?: Maybe<UpdateCiInformationPayload>,
  deleteCiInformation?: Maybe<DeleteCiInformationPayload>,
  createClient?: Maybe<CreateClientPayload>,
  updateClient?: Maybe<UpdateClientPayload>,
  deleteClient?: Maybe<DeleteClientPayload>,
  createConfiguration?: Maybe<CreateConfigurationPayload>,
  updateConfiguration?: Maybe<UpdateConfigurationPayload>,
  deleteConfiguration?: Maybe<DeleteConfigurationPayload>,
  createDocument?: Maybe<CreateDocumentPayload>,
  updateDocument?: Maybe<UpdateDocumentPayload>,
  deleteDocument?: Maybe<DeleteDocumentPayload>,
  createItemType?: Maybe<CreateItemTypePayload>,
  updateItemType?: Maybe<UpdateItemTypePayload>,
  deleteItemType?: Maybe<DeleteItemTypePayload>,
  createItem?: Maybe<CreateItemPayload>,
  updateItem?: Maybe<UpdateItemPayload>,
  deleteItem?: Maybe<DeleteItemPayload>,
  createLocation?: Maybe<CreateLocationPayload>,
  updateLocation?: Maybe<UpdateLocationPayload>,
  deleteLocation?: Maybe<DeleteLocationPayload>,
  createMessage?: Maybe<CreateMessagePayload>,
  updateMessage?: Maybe<UpdateMessagePayload>,
  deleteMessage?: Maybe<DeleteMessagePayload>,
  createNotification?: Maybe<CreateNotificationPayload>,
  updateNotification?: Maybe<UpdateNotificationPayload>,
  deleteNotification?: Maybe<DeleteNotificationPayload>,
  createQuote?: Maybe<CreateQuotePayload>,
  updateQuote?: Maybe<UpdateQuotePayload>,
  deleteQuote?: Maybe<DeleteQuotePayload>,
  createResolutionCode?: Maybe<CreateResolutionCodePayload>,
  updateResolutionCode?: Maybe<UpdateResolutionCodePayload>,
  deleteResolutionCode?: Maybe<DeleteResolutionCodePayload>,
  createSignalRegistry?: Maybe<CreateSignalRegistryPayload>,
  updateSignalRegistry?: Maybe<UpdateSignalRegistryPayload>,
  deleteSignalRegistry?: Maybe<DeleteSignalRegistryPayload>,
  createStatus?: Maybe<CreateStatusPayload>,
  updateStatus?: Maybe<UpdateStatusPayload>,
  deleteStatus?: Maybe<DeleteStatusPayload>,
  createSubFault?: Maybe<CreateSubFaultPayload>,
  updateSubFault?: Maybe<UpdateSubFaultPayload>,
  deleteSubFault?: Maybe<DeleteSubFaultPayload>,
  createTicket?: Maybe<CreateTicketPayload>,
  updateTicket?: Maybe<UpdateTicketPayload>,
  deleteTicket?: Maybe<DeleteTicketPayload>,
  createVendorInformation?: Maybe<CreateVendorInformationPayload>,
  updateVendorInformation?: Maybe<UpdateVendorInformationPayload>,
  deleteVendorInformation?: Maybe<DeleteVendorInformationPayload>,
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>,
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>,
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>,
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>,
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>,
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>,
  upload: UploadFile,
  multipleUpload: Array<Maybe<UploadFile>>,
  login: UsersPermissionsLoginPayload,
  register: UsersPermissionsLoginPayload,
};


export type MutationCreateActualFaultArgs = {
  input?: Maybe<CreateActualFaultInput>
};


export type MutationUpdateActualFaultArgs = {
  input?: Maybe<UpdateActualFaultInput>
};


export type MutationDeleteActualFaultArgs = {
  input?: Maybe<DeleteActualFaultInput>
};


export type MutationCreateCiInformationArgs = {
  input?: Maybe<CreateCiInformationInput>
};


export type MutationUpdateCiInformationArgs = {
  input?: Maybe<UpdateCiInformationInput>
};


export type MutationDeleteCiInformationArgs = {
  input?: Maybe<DeleteCiInformationInput>
};


export type MutationCreateClientArgs = {
  input?: Maybe<CreateClientInput>
};


export type MutationUpdateClientArgs = {
  input?: Maybe<UpdateClientInput>
};


export type MutationDeleteClientArgs = {
  input?: Maybe<DeleteClientInput>
};


export type MutationCreateConfigurationArgs = {
  input?: Maybe<CreateConfigurationInput>
};


export type MutationUpdateConfigurationArgs = {
  input?: Maybe<UpdateConfigurationInput>
};


export type MutationDeleteConfigurationArgs = {
  input?: Maybe<DeleteConfigurationInput>
};


export type MutationCreateDocumentArgs = {
  input?: Maybe<CreateDocumentInput>
};


export type MutationUpdateDocumentArgs = {
  input?: Maybe<UpdateDocumentInput>
};


export type MutationDeleteDocumentArgs = {
  input?: Maybe<DeleteDocumentInput>
};


export type MutationCreateItemTypeArgs = {
  input?: Maybe<CreateItemTypeInput>
};


export type MutationUpdateItemTypeArgs = {
  input?: Maybe<UpdateItemTypeInput>
};


export type MutationDeleteItemTypeArgs = {
  input?: Maybe<DeleteItemTypeInput>
};


export type MutationCreateItemArgs = {
  input?: Maybe<CreateItemInput>
};


export type MutationUpdateItemArgs = {
  input?: Maybe<UpdateItemInput>
};


export type MutationDeleteItemArgs = {
  input?: Maybe<DeleteItemInput>
};


export type MutationCreateLocationArgs = {
  input?: Maybe<CreateLocationInput>
};


export type MutationUpdateLocationArgs = {
  input?: Maybe<UpdateLocationInput>
};


export type MutationDeleteLocationArgs = {
  input?: Maybe<DeleteLocationInput>
};


export type MutationCreateMessageArgs = {
  input?: Maybe<CreateMessageInput>
};


export type MutationUpdateMessageArgs = {
  input?: Maybe<UpdateMessageInput>
};


export type MutationDeleteMessageArgs = {
  input?: Maybe<DeleteMessageInput>
};


export type MutationCreateNotificationArgs = {
  input?: Maybe<CreateNotificationInput>
};


export type MutationUpdateNotificationArgs = {
  input?: Maybe<UpdateNotificationInput>
};


export type MutationDeleteNotificationArgs = {
  input?: Maybe<DeleteNotificationInput>
};


export type MutationCreateQuoteArgs = {
  input?: Maybe<CreateQuoteInput>
};


export type MutationUpdateQuoteArgs = {
  input?: Maybe<UpdateQuoteInput>
};


export type MutationDeleteQuoteArgs = {
  input?: Maybe<DeleteQuoteInput>
};


export type MutationCreateResolutionCodeArgs = {
  input?: Maybe<CreateResolutionCodeInput>
};


export type MutationUpdateResolutionCodeArgs = {
  input?: Maybe<UpdateResolutionCodeInput>
};


export type MutationDeleteResolutionCodeArgs = {
  input?: Maybe<DeleteResolutionCodeInput>
};


export type MutationCreateSignalRegistryArgs = {
  input?: Maybe<CreateSignalRegistryInput>
};


export type MutationUpdateSignalRegistryArgs = {
  input?: Maybe<UpdateSignalRegistryInput>
};


export type MutationDeleteSignalRegistryArgs = {
  input?: Maybe<DeleteSignalRegistryInput>
};


export type MutationCreateStatusArgs = {
  input?: Maybe<CreateStatusInput>
};


export type MutationUpdateStatusArgs = {
  input?: Maybe<UpdateStatusInput>
};


export type MutationDeleteStatusArgs = {
  input?: Maybe<DeleteStatusInput>
};


export type MutationCreateSubFaultArgs = {
  input?: Maybe<CreateSubFaultInput>
};


export type MutationUpdateSubFaultArgs = {
  input?: Maybe<UpdateSubFaultInput>
};


export type MutationDeleteSubFaultArgs = {
  input?: Maybe<DeleteSubFaultInput>
};


export type MutationCreateTicketArgs = {
  input?: Maybe<CreateTicketInput>
};


export type MutationUpdateTicketArgs = {
  input?: Maybe<UpdateTicketInput>
};


export type MutationDeleteTicketArgs = {
  input?: Maybe<DeleteTicketInput>
};


export type MutationCreateVendorInformationArgs = {
  input?: Maybe<CreateVendorInformationInput>
};


export type MutationUpdateVendorInformationArgs = {
  input?: Maybe<UpdateVendorInformationInput>
};


export type MutationDeleteVendorInformationArgs = {
  input?: Maybe<DeleteVendorInformationInput>
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>,
  ref?: Maybe<Scalars['String']>,
  field?: Maybe<Scalars['String']>,
  source?: Maybe<Scalars['String']>,
  file: Scalars['Upload']
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>,
  ref?: Maybe<Scalars['String']>,
  field?: Maybe<Scalars['String']>,
  source?: Maybe<Scalars['String']>,
  files: Array<Maybe<Scalars['Upload']>>
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput
};


export type MutationRegisterArgs = {
  input: UserInput
};

export type NotificationInput = {
  ticket?: Maybe<Scalars['ID']>,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  read?: Maybe<Scalars['Boolean']>,
  client?: Maybe<Scalars['ID']>,
};

export type Notifications = {
   __typename?: 'Notifications',
  ticket?: Maybe<Ticket>,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  read?: Maybe<Scalars['Boolean']>,
  client?: Maybe<Client>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type Query = {
   __typename?: 'Query',
  actualFault?: Maybe<ActualFault>,
  actualFaults?: Maybe<Array<Maybe<ActualFault>>>,
  ciInformation?: Maybe<CiInformation>,
  ciInformations?: Maybe<Array<Maybe<CiInformation>>>,
  client?: Maybe<Client>,
  clients?: Maybe<Array<Maybe<Client>>>,
  configuration?: Maybe<Configuration>,
  configurations?: Maybe<Array<Maybe<Configuration>>>,
  document?: Maybe<Document>,
  documents?: Maybe<Array<Maybe<Document>>>,
  itemType?: Maybe<ItemType>,
  itemTypes?: Maybe<Array<Maybe<ItemType>>>,
  item?: Maybe<Item>,
  items?: Maybe<Array<Maybe<Item>>>,
  location?: Maybe<Location>,
  locations?: Maybe<Array<Maybe<Location>>>,
  message?: Maybe<Message>,
  messages?: Maybe<Array<Maybe<Message>>>,
  notification?: Maybe<Notifications>,
  notifications?: Maybe<Array<Maybe<Notifications>>>,
  quote?: Maybe<Quote>,
  quotes?: Maybe<Array<Maybe<Quote>>>,
  resolutionCode?: Maybe<ResolutionCode>,
  resolutionCodes?: Maybe<Array<Maybe<ResolutionCode>>>,
  signalRegistry?: Maybe<SignalRegistry>,
  signalRegistries?: Maybe<Array<Maybe<SignalRegistry>>>,
  status?: Maybe<Status>,
  statuses?: Maybe<Array<Maybe<Status>>>,
  subFault?: Maybe<SubFault>,
  subFaults?: Maybe<Array<Maybe<SubFault>>>,
  ticket?: Maybe<Ticket>,
  tickets?: Maybe<Array<Maybe<Ticket>>>,
  vendorInformation?: Maybe<VendorInformation>,
  vendorInformations?: Maybe<Array<Maybe<VendorInformation>>>,
  files?: Maybe<Array<Maybe<UploadFile>>>,
  role?: Maybe<UsersPermissionsRole>,
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>,
  user?: Maybe<UsersPermissionsUser>,
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>,
  me?: Maybe<UsersPermissionsMe>,
};


export type QueryActualFaultArgs = {
  id: Scalars['ID']
};


export type QueryActualFaultsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryCiInformationArgs = {
  id: Scalars['ID']
};


export type QueryCiInformationsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryClientArgs = {
  id: Scalars['ID']
};


export type QueryClientsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryConfigurationArgs = {
  id: Scalars['ID']
};


export type QueryConfigurationsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryDocumentArgs = {
  id: Scalars['ID']
};


export type QueryDocumentsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryItemTypeArgs = {
  id: Scalars['ID']
};


export type QueryItemTypesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryItemArgs = {
  id: Scalars['ID']
};


export type QueryItemsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryLocationArgs = {
  id: Scalars['ID']
};


export type QueryLocationsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryMessageArgs = {
  id: Scalars['ID']
};


export type QueryMessagesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryNotificationArgs = {
  id: Scalars['ID']
};


export type QueryNotificationsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryQuoteArgs = {
  id: Scalars['ID']
};


export type QueryQuotesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryResolutionCodeArgs = {
  id: Scalars['ID']
};


export type QueryResolutionCodesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QuerySignalRegistryArgs = {
  id: Scalars['ID']
};


export type QuerySignalRegistriesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryStatusArgs = {
  id: Scalars['ID']
};


export type QueryStatusesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QuerySubFaultArgs = {
  id: Scalars['ID']
};


export type QuerySubFaultsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryTicketArgs = {
  id: Scalars['ID']
};


export type QueryTicketsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryVendorInformationArgs = {
  id: Scalars['ID']
};


export type QueryVendorInformationsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryRoleArgs = {
  id: Scalars['ID']
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type QueryUserArgs = {
  id: Scalars['ID']
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};

export type Quote = {
   __typename?: 'Quote',
  expiryDate?: Maybe<Scalars['Date']>,
  status?: Maybe<Enum_Quote_Status>,
  termsAndConditions?: Maybe<Scalars['String']>,
  ticket?: Maybe<Ticket>,
  contractor?: Maybe<UsersPermissionsUser>,
  items?: Maybe<Array<Maybe<ComponentItemsItems>>>,
  documents?: Maybe<Array<Maybe<Document>>>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};


export type QuoteDocumentsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};

export type QuoteInput = {
  expiryDate?: Maybe<Scalars['Date']>,
  status?: Maybe<Enum_Quote_Status>,
  termsAndConditions?: Maybe<Scalars['String']>,
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>,
  ticket?: Maybe<Scalars['ID']>,
  contractor?: Maybe<Scalars['ID']>,
  items?: Maybe<Array<Maybe<ComponentItemsItemInput>>>,
};

export type ResolutionCode = {
   __typename?: 'ResolutionCode',
  resCode?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type ResolutionCodeInput = {
  resCode?: Maybe<Scalars['String']>,
};

export type RoleInput = {
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>,
  users?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type SignalRegistry = {
   __typename?: 'SignalRegistry',
  action?: Maybe<Scalars['String']>,
  entryId?: Maybe<Scalars['Int']>,
  processedState?: Maybe<Scalars['Int']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type SignalRegistryInput = {
  action?: Maybe<Scalars['String']>,
  entryId?: Maybe<Scalars['Int']>,
  processedState?: Maybe<Scalars['Int']>,
};

export type Status = {
   __typename?: 'Status',
  name?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  content?: Maybe<Scalars['String']>,
  complete?: Maybe<Scalars['Boolean']>,
  uploadRequired?: Maybe<Scalars['Boolean']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type StatusInput = {
  name?: Maybe<Scalars['String']>,
  enabled?: Maybe<Scalars['Boolean']>,
  content?: Maybe<Scalars['String']>,
  complete?: Maybe<Scalars['Boolean']>,
  uploadRequired?: Maybe<Scalars['Boolean']>,
};

export type SubFault = {
   __typename?: 'SubFault',
  subFault?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type SubFaultInput = {
  subFault?: Maybe<Scalars['String']>,
};

export type Ticket = {
   __typename?: 'Ticket',
  location?: Maybe<Location>,
  summary?: Maybe<Scalars['String']>,
  status?: Maybe<Status>,
  warranty?: Maybe<Scalars['Boolean']>,
  client?: Maybe<Client>,
  ticketSummary?: Maybe<Scalars['String']>,
  warrantyStartDate?: Maybe<Scalars['Date']>,
  warrantyEndDate?: Maybe<Scalars['Date']>,
  ticketNumber?: Maybe<Scalars['String']>,
  ticketSlaPriority?: Maybe<Scalars['String']>,
  quoteAmount?: Maybe<Scalars['Float']>,
  requestedBy?: Maybe<Scalars['String']>,
  vendor?: Maybe<VendorInformation>,
  ci?: Maybe<CiInformation>,
  resolutionCode?: Maybe<ResolutionCode>,
  actualFault?: Maybe<ActualFault>,
  subFault?: Maybe<SubFault>,
  quotes?: Maybe<Array<Maybe<Quote>>>,
  documents?: Maybe<Array<Maybe<Document>>>,
  messages?: Maybe<Array<Maybe<Message>>>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};


export type TicketQuotesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type TicketDocumentsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type TicketMessagesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};

export type TicketInput = {
  location?: Maybe<Scalars['ID']>,
  summary?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['ID']>,
  warranty?: Maybe<Scalars['Boolean']>,
  client?: Maybe<Scalars['ID']>,
  ticketSummary?: Maybe<Scalars['String']>,
  warrantyStartDate?: Maybe<Scalars['Date']>,
  warrantyEndDate?: Maybe<Scalars['Date']>,
  quotes?: Maybe<Array<Maybe<Scalars['ID']>>>,
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>,
  messages?: Maybe<Array<Maybe<Scalars['ID']>>>,
  ticketNumber?: Maybe<Scalars['String']>,
  ticketSlaPriority?: Maybe<Scalars['String']>,
  quoteAmount?: Maybe<Scalars['Float']>,
  requestedBy?: Maybe<Scalars['String']>,
  vendor?: Maybe<Scalars['ID']>,
  ci?: Maybe<Scalars['ID']>,
  resolutionCode?: Maybe<Scalars['ID']>,
  actualFault?: Maybe<Scalars['ID']>,
  subFault?: Maybe<Scalars['ID']>,
};


export type UpdateActualFaultInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditActualFaultInput>,
};

export type UpdateActualFaultPayload = {
   __typename?: 'updateActualFaultPayload',
  actualFault?: Maybe<ActualFault>,
};

export type UpdateCiInformationInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditCiInformationInput>,
};

export type UpdateCiInformationPayload = {
   __typename?: 'updateCiInformationPayload',
  ciInformation?: Maybe<CiInformation>,
};

export type UpdateClientInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditClientInput>,
};

export type UpdateClientPayload = {
   __typename?: 'updateClientPayload',
  client?: Maybe<Client>,
};

export type UpdateConfigurationInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditConfigurationInput>,
};

export type UpdateConfigurationPayload = {
   __typename?: 'updateConfigurationPayload',
  configuration?: Maybe<Configuration>,
};

export type UpdateDocumentInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditDocumentInput>,
};

export type UpdateDocumentPayload = {
   __typename?: 'updateDocumentPayload',
  document?: Maybe<Document>,
};

export type UpdateItemInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditItemInput>,
};

export type UpdateItemPayload = {
   __typename?: 'updateItemPayload',
  item?: Maybe<Item>,
};

export type UpdateItemTypeInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditItemTypeInput>,
};

export type UpdateItemTypePayload = {
   __typename?: 'updateItemTypePayload',
  itemType?: Maybe<ItemType>,
};

export type UpdateLocationInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditLocationInput>,
};

export type UpdateLocationPayload = {
   __typename?: 'updateLocationPayload',
  location?: Maybe<Location>,
};

export type UpdateMessageInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditMessageInput>,
};

export type UpdateMessagePayload = {
   __typename?: 'updateMessagePayload',
  message?: Maybe<Message>,
};

export type UpdateNotificationInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditNotificationInput>,
};

export type UpdateNotificationPayload = {
   __typename?: 'updateNotificationPayload',
  notification?: Maybe<Notifications>,
};

export type UpdateQuoteInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditQuoteInput>,
};

export type UpdateQuotePayload = {
   __typename?: 'updateQuotePayload',
  quote?: Maybe<Quote>,
};

export type UpdateResolutionCodeInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditResolutionCodeInput>,
};

export type UpdateResolutionCodePayload = {
   __typename?: 'updateResolutionCodePayload',
  resolutionCode?: Maybe<ResolutionCode>,
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditRoleInput>,
};

export type UpdateRolePayload = {
   __typename?: 'updateRolePayload',
  role?: Maybe<UsersPermissionsRole>,
};

export type UpdateSignalRegistryInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditSignalRegistryInput>,
};

export type UpdateSignalRegistryPayload = {
   __typename?: 'updateSignalRegistryPayload',
  signalRegistry?: Maybe<SignalRegistry>,
};

export type UpdateStatusInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditStatusInput>,
};

export type UpdateStatusPayload = {
   __typename?: 'updateStatusPayload',
  status?: Maybe<Status>,
};

export type UpdateSubFaultInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditSubFaultInput>,
};

export type UpdateSubFaultPayload = {
   __typename?: 'updateSubFaultPayload',
  subFault?: Maybe<SubFault>,
};

export type UpdateTicketInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditTicketInput>,
};

export type UpdateTicketPayload = {
   __typename?: 'updateTicketPayload',
  ticket?: Maybe<Ticket>,
};

export type UpdateUserInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditUserInput>,
};

export type UpdateUserPayload = {
   __typename?: 'updateUserPayload',
  user?: Maybe<UsersPermissionsUser>,
};

export type UpdateVendorInformationInput = {
  where?: Maybe<InputId>,
  data?: Maybe<EditVendorInformationInput>,
};

export type UpdateVendorInformationPayload = {
   __typename?: 'updateVendorInformationPayload',
  vendorInformation?: Maybe<VendorInformation>,
};


export type UploadFile = {
   __typename?: 'UploadFile',
  name: Scalars['String'],
  hash: Scalars['String'],
  sha256?: Maybe<Scalars['String']>,
  ext?: Maybe<Scalars['String']>,
  mime: Scalars['String'],
  size: Scalars['Float'],
  url: Scalars['String'],
  provider: Scalars['String'],
  provider_metadata?: Maybe<Scalars['JSON']>,
  related?: Maybe<Array<Maybe<Morph>>>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};

export type UserInput = {
  username: Scalars['String'],
  provider?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  resetPasswordToken?: Maybe<Scalars['String']>,
  confirmed?: Maybe<Scalars['Boolean']>,
  blocked?: Maybe<Scalars['Boolean']>,
  role?: Maybe<Scalars['ID']>,
  email?: Maybe<Scalars['String']>,
  contractorName?: Maybe<Scalars['String']>,
  quotes?: Maybe<Array<Maybe<Scalars['ID']>>>,
  client?: Maybe<Scalars['ID']>,
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'],
  password: Scalars['String'],
  provider?: Maybe<Scalars['String']>,
};

export type UsersPermissionsLoginPayload = {
   __typename?: 'UsersPermissionsLoginPayload',
  jwt: Scalars['String'],
  user: UsersPermissionsMe,
};

export type UsersPermissionsMe = {
   __typename?: 'UsersPermissionsMe',
  id: Scalars['ID'],
  username: Scalars['String'],
  email: Scalars['String'],
  confirmed?: Maybe<Scalars['Boolean']>,
  blocked?: Maybe<Scalars['Boolean']>,
  role?: Maybe<UsersPermissionsMeRole>,
};

export type UsersPermissionsMeRole = {
   __typename?: 'UsersPermissionsMeRole',
  id: Scalars['ID'],
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
};

export type UsersPermissionsPermission = {
   __typename?: 'UsersPermissionsPermission',
  type: Scalars['String'],
  controller: Scalars['String'],
  action: Scalars['String'],
  enabled: Scalars['Boolean'],
  policy?: Maybe<Scalars['String']>,
  role?: Maybe<UsersPermissionsRole>,
  id: Scalars['ID'],
};

export type UsersPermissionsRole = {
   __typename?: 'UsersPermissionsRole',
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>,
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>,
  id: Scalars['ID'],
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};

export type UsersPermissionsUser = {
   __typename?: 'UsersPermissionsUser',
  username: Scalars['String'],
  provider?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  confirmed?: Maybe<Scalars['Boolean']>,
  blocked?: Maybe<Scalars['Boolean']>,
  role?: Maybe<UsersPermissionsRole>,
  email?: Maybe<Scalars['String']>,
  contractorName?: Maybe<Scalars['String']>,
  client?: Maybe<Client>,
  quotes?: Maybe<Array<Maybe<Quote>>>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};


export type UsersPermissionsUserQuotesArgs = {
  sort?: Maybe<Scalars['String']>,
  limit?: Maybe<Scalars['Int']>,
  start?: Maybe<Scalars['Int']>,
  where?: Maybe<Scalars['JSON']>
};

export type VendorInformation = {
   __typename?: 'VendorInformation',
  vendorRef?: Maybe<Scalars['String']>,
  dispatchDate?: Maybe<Scalars['DateTime']>,
  expectedArrival?: Maybe<Scalars['DateTime']>,
  actualArrival?: Maybe<Scalars['DateTime']>,
  id: Scalars['ID'],
  created_at: Scalars['DateTime'],
  updated_at: Scalars['DateTime'],
};

export type VendorInformationInput = {
  vendorRef?: Maybe<Scalars['String']>,
  dispatchDate?: Maybe<Scalars['DateTime']>,
  expectedArrival?: Maybe<Scalars['DateTime']>,
  actualArrival?: Maybe<Scalars['DateTime']>,
};

export type CreateCiInformationMutationVariables = {
  input?: Maybe<CiInformationInput>
};


export type CreateCiInformationMutation = (
  { __typename?: 'Mutation' }
  & { createCiInformation: Maybe<(
    { __typename?: 'createCiInformationPayload' }
    & { ciInformation: Maybe<(
      { __typename?: 'CiInformation' }
      & Pick<CiInformation, 'id' | 'ciName' | 'serialNum' | 'ciLocation'>
    )> }
  )> }
);

export type CreateDocumentMutationVariables = {
  input?: Maybe<DocumentInput>
};


export type CreateDocumentMutation = (
  { __typename?: 'Mutation' }
  & { createDocument: Maybe<(
    { __typename?: 'createDocumentPayload' }
    & { document: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'name' | 'from'>
      & { file: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url'>
      )> }
    )> }
  )> }
);

export type CreateMessageMutationVariables = {
  input?: Maybe<MessageInput>
};


export type CreateMessageMutation = (
  { __typename?: 'Mutation' }
  & { createMessage: Maybe<(
    { __typename?: 'createMessagePayload' }
    & { message: Maybe<(
      { __typename?: 'Message' }
      & Pick<Message, 'id' | 'title' | 'description' | 'created_at' | 'updated_at'>
      & { ticket: Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'id' | 'ticketNumber'>
      )> }
    )> }
  )> }
);

export type CreateNotificationMutationVariables = {
  input?: Maybe<NotificationInput>
};


export type CreateNotificationMutation = (
  { __typename?: 'Mutation' }
  & { createNotification: Maybe<(
    { __typename?: 'createNotificationPayload' }
    & { notification: Maybe<(
      { __typename?: 'Notifications' }
      & Pick<Notifications, 'id' | 'title' | 'description' | 'read' | 'created_at' | 'updated_at'>
      & { client: Maybe<(
        { __typename?: 'Client' }
        & Pick<Client, 'id'>
      )> }
    )> }
  )> }
);

export type CreateQuoteMutationVariables = {
  input?: Maybe<QuoteInput>
};


export type CreateQuoteMutation = (
  { __typename?: 'Mutation' }
  & { createQuote: Maybe<(
    { __typename?: 'createQuotePayload' }
    & { quote: Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'expiryDate' | 'status' | 'termsAndConditions'>
      & { contractor: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'username' | 'email' | 'contractorName'>
        & { client: Maybe<(
          { __typename?: 'Client' }
          & Pick<Client, 'name' | 'vatNumber'>
        )> }
      )>, ticket: Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'id'>
      )>, items: Maybe<Array<Maybe<(
        { __typename?: 'ComponentItemsItems' }
        & Pick<ComponentItemsItems, 'id' | 'unitPrice' | 'quantity' | 'totalPrice' | 'description'>
        & { item: Maybe<(
          { __typename?: 'Item' }
          & Pick<Item, 'id' | 'name' | 'description' | 'recommendedUnitPrice'>
        )> }
      )>>>, documents: Maybe<Array<Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'name'>
        & { file: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>>> }
    )> }
  )> }
);

export type CreateSignalRegistryMutationVariables = {
  input?: Maybe<SignalRegistryInput>
};


export type CreateSignalRegistryMutation = (
  { __typename?: 'Mutation' }
  & { createSignalRegistry: Maybe<(
    { __typename?: 'createSignalRegistryPayload' }
    & { signalRegistry: Maybe<(
      { __typename?: 'SignalRegistry' }
      & Pick<SignalRegistry, 'id' | 'action' | 'entryId' | 'processedState' | 'created_at' | 'updated_at'>
    )> }
  )> }
);

export type CreateUserMutationVariables = {
  input?: Maybe<UserInput>
};


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser: Maybe<(
    { __typename?: 'createUserPayload' }
    & { user: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'created_at' | 'updated_at' | 'username' | 'email' | 'provider' | 'confirmed' | 'blocked'>
      & { role: Maybe<(
        { __typename?: 'UsersPermissionsRole' }
        & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
      )> }
    )> }
  )> }
);

export type CreateVendorInformationMutationVariables = {
  input?: Maybe<VendorInformationInput>
};


export type CreateVendorInformationMutation = (
  { __typename?: 'Mutation' }
  & { createVendorInformation: Maybe<(
    { __typename?: 'createVendorInformationPayload' }
    & { vendorInformation: Maybe<(
      { __typename?: 'VendorInformation' }
      & Pick<VendorInformation, 'id' | 'vendorRef' | 'dispatchDate' | 'expectedArrival' | 'actualArrival'>
    )> }
  )> }
);

export type DeleteDocumentMutationVariables = {
  id: Scalars['ID']
};


export type DeleteDocumentMutation = (
  { __typename?: 'Mutation' }
  & { deleteDocument: Maybe<(
    { __typename?: 'deleteDocumentPayload' }
    & { document: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id'>
    )> }
  )> }
);

export type DeleteQuoteMutationVariables = {
  id: Scalars['ID']
};


export type DeleteQuoteMutation = (
  { __typename?: 'Mutation' }
  & { deleteQuote: Maybe<(
    { __typename?: 'deleteQuotePayload' }
    & { quote: Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id'>
    )> }
  )> }
);

export type UpdateCiInformationMutationVariables = {
  id: Scalars['ID'],
  input?: Maybe<EditCiInformationInput>
};


export type UpdateCiInformationMutation = (
  { __typename?: 'Mutation' }
  & { updateCiInformation: Maybe<(
    { __typename?: 'updateCiInformationPayload' }
    & { ciInformation: Maybe<(
      { __typename?: 'CiInformation' }
      & Pick<CiInformation, 'id' | 'ciName' | 'serialNum' | 'ciLocation'>
    )> }
  )> }
);

export type UpdateNotificationMutationVariables = {
  id: Scalars['ID'],
  input?: Maybe<EditNotificationInput>
};


export type UpdateNotificationMutation = (
  { __typename?: 'Mutation' }
  & { updateNotification: Maybe<(
    { __typename?: 'updateNotificationPayload' }
    & { notification: Maybe<(
      { __typename?: 'Notifications' }
      & Pick<Notifications, 'id' | 'read' | 'title' | 'description' | 'created_at' | 'updated_at'>
      & { ticket: Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'id' | 'summary' | 'ticketSummary' | 'warranty'>
        & { status: Maybe<(
          { __typename?: 'Status' }
          & Pick<Status, 'name'>
        )>, location: Maybe<(
          { __typename?: 'Location' }
          & Pick<Location, 'address'>
        )> }
      )>, client: Maybe<(
        { __typename?: 'Client' }
        & Pick<Client, 'id' | 'name' | 'vatNumber'>
      )> }
    )> }
  )> }
);

export type UpdateQuoteMutationVariables = {
  id: Scalars['ID'],
  input?: Maybe<EditQuoteInput>
};


export type UpdateQuoteMutation = (
  { __typename?: 'Mutation' }
  & { updateQuote: Maybe<(
    { __typename?: 'updateQuotePayload' }
    & { quote: Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'expiryDate' | 'status' | 'termsAndConditions'>
      & { contractor: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'username' | 'email' | 'contractorName'>
        & { client: Maybe<(
          { __typename?: 'Client' }
          & Pick<Client, 'name'>
        )> }
      )>, ticket: Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'id'>
      )>, items: Maybe<Array<Maybe<(
        { __typename?: 'ComponentItemsItems' }
        & Pick<ComponentItemsItems, 'id' | 'unitPrice' | 'quantity' | 'totalPrice' | 'description'>
        & { item: Maybe<(
          { __typename?: 'Item' }
          & Pick<Item, 'id' | 'name' | 'description' | 'recommendedUnitPrice'>
        )>, itemType: Maybe<(
          { __typename?: 'ItemType' }
          & Pick<ItemType, 'id' | 'name' | 'description'>
        )> }
      )>>>, documents: Maybe<Array<Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'name'>
        & { file: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>>> }
    )> }
  )> }
);

export type UpdateTicketMutationVariables = {
  id: Scalars['ID'],
  input?: Maybe<EditTicketInput>
};


export type UpdateTicketMutation = (
  { __typename?: 'Mutation' }
  & { updateTicket: Maybe<(
    { __typename?: 'updateTicketPayload' }
    & { ticket: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'ticketNumber' | 'summary' | 'warranty' | 'ticketSummary' | 'quoteAmount' | 'warrantyStartDate' | 'warrantyEndDate' | 'created_at' | 'updated_at'>
      & { location: Maybe<(
        { __typename?: 'Location' }
        & Pick<Location, 'id' | 'name' | 'address' | 'enabled' | 'googleMaps'>
      )>, status: Maybe<(
        { __typename?: 'Status' }
        & Pick<Status, 'id' | 'name' | 'enabled' | 'content'>
      )>, client: Maybe<(
        { __typename?: 'Client' }
        & Pick<Client, 'id' | 'name'>
        & { tickets: Maybe<Array<Maybe<(
          { __typename?: 'Ticket' }
          & Pick<Ticket, 'id'>
        )>>> }
      )>, documents: Maybe<Array<Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'name'>
        & { file: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>>>, messages: Maybe<Array<Maybe<(
        { __typename?: 'Message' }
        & Pick<Message, 'id' | 'title' | 'description' | 'updated_at'>
        & { ticket: Maybe<(
          { __typename?: 'Ticket' }
          & Pick<Ticket, 'id'>
        )> }
      )>>>, vendor: Maybe<(
        { __typename?: 'VendorInformation' }
        & Pick<VendorInformation, 'id' | 'vendorRef' | 'dispatchDate' | 'expectedArrival' | 'actualArrival'>
      )>, ci: Maybe<(
        { __typename?: 'CiInformation' }
        & Pick<CiInformation, 'id' | 'ciName' | 'serialNum' | 'ciLocation'>
      )>, actualFault: Maybe<(
        { __typename?: 'ActualFault' }
        & Pick<ActualFault, 'id'>
      )>, resolutionCode: Maybe<(
        { __typename?: 'ResolutionCode' }
        & Pick<ResolutionCode, 'id'>
      )>, subFault: Maybe<(
        { __typename?: 'SubFault' }
        & Pick<SubFault, 'id'>
      )> }
    )> }
  )> }
);

export type UpdateUserMutationVariables = {
  id: Scalars['ID'],
  input?: Maybe<EditUserInput>
};


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser: Maybe<(
    { __typename?: 'updateUserPayload' }
    & { user: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'username' | 'email' | 'confirmed' | 'password' | 'blocked'>
      & { role: Maybe<(
        { __typename?: 'UsersPermissionsRole' }
        & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
      )> }
    )> }
  )> }
);

export type UpdateVendorInformationMutationVariables = {
  id: Scalars['ID'],
  input?: Maybe<EditVendorInformationInput>
};


export type UpdateVendorInformationMutation = (
  { __typename?: 'Mutation' }
  & { updateVendorInformation: Maybe<(
    { __typename?: 'updateVendorInformationPayload' }
    & { vendorInformation: Maybe<(
      { __typename?: 'VendorInformation' }
      & Pick<VendorInformation, 'id' | 'vendorRef' | 'dispatchDate' | 'expectedArrival' | 'actualArrival'>
    )> }
  )> }
);

export type GetActualFaultsQueryVariables = {};


export type GetActualFaultsQuery = (
  { __typename?: 'Query' }
  & { actualFaults: Maybe<Array<Maybe<(
    { __typename?: 'ActualFault' }
    & Pick<ActualFault, 'id' | 'fault'>
  )>>> }
);

export type GetConfigurationQueryVariables = {};


export type GetConfigurationQuery = (
  { __typename?: 'Query' }
  & { configurations: Maybe<Array<Maybe<(
    { __typename?: 'Configuration' }
    & Pick<Configuration, 'showWarranty' | 'showQuoteBuilder' | 'showDocuments' | 'showVendorInfo' | 'showCiInfo' | 'showClosingInfo' | 'created_at'>
  )>>> }
);

export type GetItemTypesQueryVariables = {};


export type GetItemTypesQuery = (
  { __typename?: 'Query' }
  & { itemTypes: Maybe<Array<Maybe<(
    { __typename?: 'ItemType' }
    & Pick<ItemType, 'id' | 'name' | 'description'>
  )>>> }
);

export type GetItemsQueryVariables = {};


export type GetItemsQuery = (
  { __typename?: 'Query' }
  & { items: Maybe<Array<Maybe<(
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'name' | 'description' | 'recommendedUnitPrice'>
  )>>> }
);

export type GetMessageQueryVariables = {
  ticketId: Scalars['ID'],
  messageId: Scalars['ID']
};


export type GetMessageQuery = (
  { __typename?: 'Query' }
  & { messages: Maybe<Array<Maybe<(
    { __typename?: 'Message' }
    & Pick<Message, 'id' | 'title' | 'description' | 'created_at' | 'updated_at'>
    & { ticket: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'ticketNumber'>
    )> }
  )>>> }
);

export type GetMessagesQueryVariables = {
  ticketId: Scalars['ID']
};


export type GetMessagesQuery = (
  { __typename?: 'Query' }
  & { messages: Maybe<Array<Maybe<(
    { __typename?: 'Message' }
    & Pick<Message, 'id' | 'title' | 'description' | 'created_at' | 'updated_at'>
    & { ticket: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'ticketNumber'>
    )> }
  )>>> }
);

export type GetNotificationsQueryVariables = {
  clientId: Scalars['ID']
};


export type GetNotificationsQuery = (
  { __typename?: 'Query' }
  & { notifications: Maybe<Array<Maybe<(
    { __typename?: 'Notifications' }
    & Pick<Notifications, 'id' | 'title' | 'description' | 'created_at' | 'updated_at'>
    & { ticket: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'summary' | 'ticketSummary' | 'ticketNumber' | 'warranty'>
      & { status: Maybe<(
        { __typename?: 'Status' }
        & Pick<Status, 'name'>
      )>, location: Maybe<(
        { __typename?: 'Location' }
        & Pick<Location, 'address'>
      )> }
    )>, client: Maybe<(
      { __typename?: 'Client' }
      & Pick<Client, 'id' | 'name' | 'vatNumber'>
    )> }
  )>>> }
);

export type GetQuoteQueryVariables = {
  quoteId: Scalars['ID']
};


export type GetQuoteQuery = (
  { __typename?: 'Query' }
  & { quote: Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'id' | 'expiryDate' | 'status' | 'termsAndConditions' | 'created_at' | 'updated_at'>
    & { contractor: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'username' | 'email' | 'confirmed' | 'contractorName'>
      & { client: Maybe<(
        { __typename?: 'Client' }
        & Pick<Client, 'name' | 'vatNumber'>
      )>, quotes: Maybe<Array<Maybe<(
        { __typename?: 'Quote' }
        & Pick<Quote, 'id'>
      )>>> }
    )>, ticket: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id'>
    )>, items: Maybe<Array<Maybe<(
      { __typename?: 'ComponentItemsItems' }
      & Pick<ComponentItemsItems, 'id' | 'unitPrice' | 'quantity' | 'totalPrice' | 'description'>
      & { item: Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'name' | 'description' | 'recommendedUnitPrice'>
      )>, itemType: Maybe<(
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'name' | 'description'>
      )> }
    )>>>, documents: Maybe<Array<Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'name'>
      & { file: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url'>
      )> }
    )>>> }
  )> }
);

export type GetQuotesQueryVariables = {
  ticketId: Scalars['ID']
};


export type GetQuotesQuery = (
  { __typename?: 'Query' }
  & { quotes: Maybe<Array<Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'id' | 'expiryDate' | 'status' | 'termsAndConditions' | 'created_at' | 'updated_at'>
    & { contractor: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'username' | 'email' | 'confirmed' | 'contractorName'>
      & { client: Maybe<(
        { __typename?: 'Client' }
        & Pick<Client, 'name' | 'vatNumber'>
      )>, quotes: Maybe<Array<Maybe<(
        { __typename?: 'Quote' }
        & Pick<Quote, 'id'>
      )>>> }
    )>, ticket: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id'>
    )>, items: Maybe<Array<Maybe<(
      { __typename?: 'ComponentItemsItems' }
      & Pick<ComponentItemsItems, 'id' | 'unitPrice' | 'quantity' | 'totalPrice' | 'description'>
      & { item: Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'name' | 'description' | 'recommendedUnitPrice'>
      )> }
    )>>>, documents: Maybe<Array<Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'name'>
      & { file: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url'>
      )> }
    )>>> }
  )>>> }
);

export type GetResolutionCodesQueryVariables = {};


export type GetResolutionCodesQuery = (
  { __typename?: 'Query' }
  & { resolutionCodes: Maybe<Array<Maybe<(
    { __typename?: 'ResolutionCode' }
    & Pick<ResolutionCode, 'id' | 'resCode'>
  )>>> }
);

export type GetStatusesQueryVariables = {};


export type GetStatusesQuery = (
  { __typename?: 'Query' }
  & { statuses: Maybe<Array<Maybe<(
    { __typename?: 'Status' }
    & Pick<Status, 'id' | 'name' | 'content' | 'uploadRequired' | 'enabled'>
  )>>> }
);

export type GetSubFaultsQueryVariables = {};


export type GetSubFaultsQuery = (
  { __typename?: 'Query' }
  & { subFaults: Maybe<Array<Maybe<(
    { __typename?: 'SubFault' }
    & Pick<SubFault, 'id' | 'subFault'>
  )>>> }
);

export type GetTicketQueryVariables = {
  ticketId: Scalars['ID']
};


export type GetTicketQuery = (
  { __typename?: 'Query' }
  & { ticket: Maybe<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id' | 'ticketNumber' | 'requestedBy' | 'summary' | 'warranty' | 'ticketSummary' | 'ticketSlaPriority' | 'warrantyStartDate' | 'warrantyEndDate' | 'quoteAmount' | 'created_at' | 'updated_at'>
    & { location: Maybe<(
      { __typename?: 'Location' }
      & Pick<Location, 'id' | 'name' | 'address' | 'enabled' | 'googleMaps'>
    )>, status: Maybe<(
      { __typename?: 'Status' }
      & Pick<Status, 'id' | 'name' | 'enabled' | 'content' | 'complete' | 'uploadRequired'>
    )>, client: Maybe<(
      { __typename?: 'Client' }
      & Pick<Client, 'id' | 'name'>
      & { tickets: Maybe<Array<Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'id'>
      )>>> }
    )>, messages: Maybe<Array<Maybe<(
      { __typename?: 'Message' }
      & Pick<Message, 'id' | 'title' | 'description' | 'created_at' | 'updated_at'>
      & { ticket: Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'id'>
      )> }
    )>>>, documents: Maybe<Array<Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'name' | 'created_at'>
      & { file: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url'>
      )> }
    )>>>, vendor: Maybe<(
      { __typename?: 'VendorInformation' }
      & Pick<VendorInformation, 'id' | 'vendorRef' | 'dispatchDate' | 'expectedArrival' | 'actualArrival'>
    )>, ci: Maybe<(
      { __typename?: 'CiInformation' }
      & Pick<CiInformation, 'id' | 'ciName' | 'serialNum' | 'ciLocation'>
    )>, resolutionCode: Maybe<(
      { __typename?: 'ResolutionCode' }
      & Pick<ResolutionCode, 'id' | 'resCode'>
    )>, actualFault: Maybe<(
      { __typename?: 'ActualFault' }
      & Pick<ActualFault, 'id' | 'fault'>
    )>, subFault: Maybe<(
      { __typename?: 'SubFault' }
      & Pick<SubFault, 'id' | 'subFault'>
    )> }
  )> }
);

export type GetTicketsQueryVariables = {
  filter?: Maybe<Scalars['JSON']>,
  start?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type GetTicketsQuery = (
  { __typename?: 'Query' }
  & { tickets: Maybe<Array<Maybe<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id' | 'ticketNumber' | 'requestedBy' | 'summary' | 'warranty' | 'ticketSummary' | 'ticketSlaPriority' | 'warrantyStartDate' | 'warrantyEndDate' | 'quoteAmount' | 'created_at' | 'updated_at'>
    & { location: Maybe<(
      { __typename?: 'Location' }
      & Pick<Location, 'id' | 'name' | 'address' | 'enabled' | 'googleMaps'>
    )>, status: Maybe<(
      { __typename?: 'Status' }
      & Pick<Status, 'id' | 'name' | 'enabled' | 'content' | 'complete'>
    )>, client: Maybe<(
      { __typename?: 'Client' }
      & Pick<Client, 'id' | 'name'>
      & { tickets: Maybe<Array<Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'id'>
      )>>> }
    )>, messages: Maybe<Array<Maybe<(
      { __typename?: 'Message' }
      & Pick<Message, 'id' | 'title' | 'description' | 'created_at' | 'updated_at'>
      & { ticket: Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'id'>
      )> }
    )>>>, documents: Maybe<Array<Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'name'>
      & { file: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url'>
      )> }
    )>>> }
  )>>> }
);

export type GetTicketsCountQueryVariables = {
  filter?: Maybe<Scalars['JSON']>
};


export type GetTicketsCountQuery = (
  { __typename?: 'Query' }
  & { tickets: Maybe<Array<Maybe<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id'>
  )>>> }
);

export type GetUserQueryVariables = {
  id: Scalars['ID']
};


export type GetUserQuery = (
  { __typename?: 'Query' }
  & { user: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id' | 'username' | 'email' | 'confirmed' | 'blocked'>
    & { role: Maybe<(
      { __typename?: 'UsersPermissionsRole' }
      & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
    )>, client: Maybe<(
      { __typename?: 'Client' }
      & Pick<Client, 'id' | 'name' | 'vatNumber'>
    )> }
  )> }
);

export type ListUsersQueryVariables = {};


export type ListUsersQuery = (
  { __typename?: 'Query' }
  & { users: Maybe<Array<Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id' | 'created_at' | 'updated_at' | 'username' | 'email' | 'provider' | 'confirmed' | 'blocked'>
    & { role: Maybe<(
      { __typename?: 'UsersPermissionsRole' }
      & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
    )> }
  )>>> }
);

export type GetMeQueryVariables = {};


export type GetMeQuery = (
  { __typename?: 'Query' }
  & { me: Maybe<(
    { __typename?: 'UsersPermissionsMe' }
    & Pick<UsersPermissionsMe, 'id' | 'username' | 'email' | 'confirmed' | 'blocked'>
    & { role: Maybe<(
      { __typename?: 'UsersPermissionsMeRole' }
      & Pick<UsersPermissionsMeRole, 'id' | 'name' | 'description' | 'type'>
    )> }
  )> }
);


export const CreateCiInformationDocument = gql`
    mutation createCiInformation($input: CiInformationInput) {
  createCiInformation(input: {data: $input}) {
    ciInformation {
      id
      ciName
      serialNum
      ciLocation
    }
  }
}
    `;
export type CreateCiInformationMutationFn = ApolloReactCommon.MutationFunction<CreateCiInformationMutation, CreateCiInformationMutationVariables>;
export type CreateCiInformationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCiInformationMutation, CreateCiInformationMutationVariables>, 'mutation'>;

    export const CreateCiInformationComponent = (props: CreateCiInformationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateCiInformationMutation, CreateCiInformationMutationVariables> mutation={CreateCiInformationDocument} {...props} />
    );
    
export type CreateCiInformationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateCiInformationMutation, CreateCiInformationMutationVariables> | TChildProps;
export function withCreateCiInformation<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCiInformationMutation,
  CreateCiInformationMutationVariables,
  CreateCiInformationProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCiInformationMutation, CreateCiInformationMutationVariables, CreateCiInformationProps<TChildProps>>(CreateCiInformationDocument, {
      alias: 'createCiInformation',
      ...operationOptions
    });
};

/**
 * __useCreateCiInformationMutation__
 *
 * To run a mutation, you first call `useCreateCiInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCiInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCiInformationMutation, { data, loading, error }] = useCreateCiInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCiInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCiInformationMutation, CreateCiInformationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCiInformationMutation, CreateCiInformationMutationVariables>(CreateCiInformationDocument, baseOptions);
      }
export type CreateCiInformationMutationHookResult = ReturnType<typeof useCreateCiInformationMutation>;
export type CreateCiInformationMutationResult = ApolloReactCommon.MutationResult<CreateCiInformationMutation>;
export type CreateCiInformationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCiInformationMutation, CreateCiInformationMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation createDocument($input: DocumentInput) {
  createDocument(input: {data: $input}) {
    document {
      id
      name
      file {
        url
      }
      from
    }
  }
}
    `;
export type CreateDocumentMutationFn = ApolloReactCommon.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;
export type CreateDocumentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDocumentMutation, CreateDocumentMutationVariables>, 'mutation'>;

    export const CreateDocumentComponent = (props: CreateDocumentComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDocumentMutation, CreateDocumentMutationVariables> mutation={CreateDocumentDocument} {...props} />
    );
    
export type CreateDocumentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateDocumentMutation, CreateDocumentMutationVariables> | TChildProps;
export function withCreateDocument<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDocumentMutation,
  CreateDocumentMutationVariables,
  CreateDocumentProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDocumentMutation, CreateDocumentMutationVariables, CreateDocumentProps<TChildProps>>(CreateDocumentDocument, {
      alias: 'createDocument',
      ...operationOptions
    });
};

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, baseOptions);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = ApolloReactCommon.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const CreateMessageDocument = gql`
    mutation createMessage($input: MessageInput) {
  createMessage(input: {data: $input}) {
    message {
      id
      title
      description
      ticket {
        id
        ticketNumber
      }
      created_at
      updated_at
    }
  }
}
    `;
export type CreateMessageMutationFn = ApolloReactCommon.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;
export type CreateMessageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateMessageMutation, CreateMessageMutationVariables>, 'mutation'>;

    export const CreateMessageComponent = (props: CreateMessageComponentProps) => (
      <ApolloReactComponents.Mutation<CreateMessageMutation, CreateMessageMutationVariables> mutation={CreateMessageDocument} {...props} />
    );
    
export type CreateMessageProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateMessageMutation, CreateMessageMutationVariables> | TChildProps;
export function withCreateMessage<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateMessageMutation,
  CreateMessageMutationVariables,
  CreateMessageProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateMessageMutation, CreateMessageMutationVariables, CreateMessageProps<TChildProps>>(CreateMessageDocument, {
      alias: 'createMessage',
      ...operationOptions
    });
};

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, baseOptions);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = ApolloReactCommon.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const CreateNotificationDocument = gql`
    mutation createNotification($input: NotificationInput) {
  createNotification(input: {data: $input}) {
    notification {
      id
      client {
        id
      }
      title
      description
      read
      created_at
      updated_at
    }
  }
}
    `;
export type CreateNotificationMutationFn = ApolloReactCommon.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;
export type CreateNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateNotificationMutation, CreateNotificationMutationVariables>, 'mutation'>;

    export const CreateNotificationComponent = (props: CreateNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateNotificationMutation, CreateNotificationMutationVariables> mutation={CreateNotificationDocument} {...props} />
    );
    
export type CreateNotificationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateNotificationMutation, CreateNotificationMutationVariables> | TChildProps;
export function withCreateNotification<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateNotificationMutation,
  CreateNotificationMutationVariables,
  CreateNotificationProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateNotificationMutation, CreateNotificationMutationVariables, CreateNotificationProps<TChildProps>>(CreateNotificationDocument, {
      alias: 'createNotification',
      ...operationOptions
    });
};

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, baseOptions);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = ApolloReactCommon.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const CreateQuoteDocument = gql`
    mutation createQuote($input: QuoteInput) {
  createQuote(input: {data: $input}) {
    quote {
      id
      contractor {
        username
        email
        contractorName
        client {
          name
          vatNumber
        }
      }
      expiryDate
      status
      termsAndConditions
      ticket {
        id
      }
      items {
        item {
          id
          name
          description
          recommendedUnitPrice
        }
        id
        unitPrice
        quantity
        totalPrice
        description
      }
      documents {
        id
        name
        file {
          url
        }
      }
    }
  }
}
    `;
export type CreateQuoteMutationFn = ApolloReactCommon.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>;
export type CreateQuoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateQuoteMutation, CreateQuoteMutationVariables>, 'mutation'>;

    export const CreateQuoteComponent = (props: CreateQuoteComponentProps) => (
      <ApolloReactComponents.Mutation<CreateQuoteMutation, CreateQuoteMutationVariables> mutation={CreateQuoteDocument} {...props} />
    );
    
export type CreateQuoteProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateQuoteMutation, CreateQuoteMutationVariables> | TChildProps;
export function withCreateQuote<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateQuoteMutation,
  CreateQuoteMutationVariables,
  CreateQuoteProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateQuoteMutation, CreateQuoteMutationVariables, CreateQuoteProps<TChildProps>>(CreateQuoteDocument, {
      alias: 'createQuote',
      ...operationOptions
    });
};

/**
 * __useCreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteMutation, { data, loading, error }] = useCreateQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQuoteMutation, CreateQuoteMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, baseOptions);
      }
export type CreateQuoteMutationHookResult = ReturnType<typeof useCreateQuoteMutation>;
export type CreateQuoteMutationResult = ApolloReactCommon.MutationResult<CreateQuoteMutation>;
export type CreateQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateQuoteMutation, CreateQuoteMutationVariables>;
export const CreateSignalRegistryDocument = gql`
    mutation createSignalRegistry($input: SignalRegistryInput) {
  createSignalRegistry(input: {data: $input}) {
    signalRegistry {
      id
      action
      entryId
      processedState
      created_at
      updated_at
    }
  }
}
    `;
export type CreateSignalRegistryMutationFn = ApolloReactCommon.MutationFunction<CreateSignalRegistryMutation, CreateSignalRegistryMutationVariables>;
export type CreateSignalRegistryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSignalRegistryMutation, CreateSignalRegistryMutationVariables>, 'mutation'>;

    export const CreateSignalRegistryComponent = (props: CreateSignalRegistryComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSignalRegistryMutation, CreateSignalRegistryMutationVariables> mutation={CreateSignalRegistryDocument} {...props} />
    );
    
export type CreateSignalRegistryProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateSignalRegistryMutation, CreateSignalRegistryMutationVariables> | TChildProps;
export function withCreateSignalRegistry<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSignalRegistryMutation,
  CreateSignalRegistryMutationVariables,
  CreateSignalRegistryProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSignalRegistryMutation, CreateSignalRegistryMutationVariables, CreateSignalRegistryProps<TChildProps>>(CreateSignalRegistryDocument, {
      alias: 'createSignalRegistry',
      ...operationOptions
    });
};

/**
 * __useCreateSignalRegistryMutation__
 *
 * To run a mutation, you first call `useCreateSignalRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignalRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignalRegistryMutation, { data, loading, error }] = useCreateSignalRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSignalRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSignalRegistryMutation, CreateSignalRegistryMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSignalRegistryMutation, CreateSignalRegistryMutationVariables>(CreateSignalRegistryDocument, baseOptions);
      }
export type CreateSignalRegistryMutationHookResult = ReturnType<typeof useCreateSignalRegistryMutation>;
export type CreateSignalRegistryMutationResult = ApolloReactCommon.MutationResult<CreateSignalRegistryMutation>;
export type CreateSignalRegistryMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSignalRegistryMutation, CreateSignalRegistryMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: UserInput) {
  createUser(input: {data: $input}) {
    user {
      id
      created_at
      updated_at
      username
      email
      provider
      confirmed
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
}
    `;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;
export type CreateUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateUserMutation, CreateUserMutationVariables>, 'mutation'>;

    export const CreateUserComponent = (props: CreateUserComponentProps) => (
      <ApolloReactComponents.Mutation<CreateUserMutation, CreateUserMutationVariables> mutation={CreateUserDocument} {...props} />
    );
    
export type CreateUserProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateUserMutation, CreateUserMutationVariables> | TChildProps;
export function withCreateUser<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateUserMutation,
  CreateUserMutationVariables,
  CreateUserProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateUserMutation, CreateUserMutationVariables, CreateUserProps<TChildProps>>(CreateUserDocument, {
      alias: 'createUser',
      ...operationOptions
    });
};

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, baseOptions);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateVendorInformationDocument = gql`
    mutation createVendorInformation($input: VendorInformationInput) {
  createVendorInformation(input: {data: $input}) {
    vendorInformation {
      id
      vendorRef
      dispatchDate
      expectedArrival
      actualArrival
    }
  }
}
    `;
export type CreateVendorInformationMutationFn = ApolloReactCommon.MutationFunction<CreateVendorInformationMutation, CreateVendorInformationMutationVariables>;
export type CreateVendorInformationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateVendorInformationMutation, CreateVendorInformationMutationVariables>, 'mutation'>;

    export const CreateVendorInformationComponent = (props: CreateVendorInformationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateVendorInformationMutation, CreateVendorInformationMutationVariables> mutation={CreateVendorInformationDocument} {...props} />
    );
    
export type CreateVendorInformationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateVendorInformationMutation, CreateVendorInformationMutationVariables> | TChildProps;
export function withCreateVendorInformation<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateVendorInformationMutation,
  CreateVendorInformationMutationVariables,
  CreateVendorInformationProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateVendorInformationMutation, CreateVendorInformationMutationVariables, CreateVendorInformationProps<TChildProps>>(CreateVendorInformationDocument, {
      alias: 'createVendorInformation',
      ...operationOptions
    });
};

/**
 * __useCreateVendorInformationMutation__
 *
 * To run a mutation, you first call `useCreateVendorInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorInformationMutation, { data, loading, error }] = useCreateVendorInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVendorInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateVendorInformationMutation, CreateVendorInformationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateVendorInformationMutation, CreateVendorInformationMutationVariables>(CreateVendorInformationDocument, baseOptions);
      }
export type CreateVendorInformationMutationHookResult = ReturnType<typeof useCreateVendorInformationMutation>;
export type CreateVendorInformationMutationResult = ApolloReactCommon.MutationResult<CreateVendorInformationMutation>;
export type CreateVendorInformationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateVendorInformationMutation, CreateVendorInformationMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($id: ID!) {
  deleteDocument(input: {where: {id: $id}}) {
    document {
      id
    }
  }
}
    `;
export type DeleteDocumentMutationFn = ApolloReactCommon.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export type DeleteDocumentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>, 'mutation'>;

    export const DeleteDocumentComponent = (props: DeleteDocumentComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteDocumentMutation, DeleteDocumentMutationVariables> mutation={DeleteDocumentDocument} {...props} />
    );
    
export type DeleteDocumentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteDocumentMutation, DeleteDocumentMutationVariables> | TChildProps;
export function withDeleteDocument<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables,
  DeleteDocumentProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteDocumentMutation, DeleteDocumentMutationVariables, DeleteDocumentProps<TChildProps>>(DeleteDocumentDocument, {
      alias: 'deleteDocument',
      ...operationOptions
    });
};

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, baseOptions);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = ApolloReactCommon.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const DeleteQuoteDocument = gql`
    mutation deleteQuote($id: ID!) {
  deleteQuote(input: {where: {id: $id}}) {
    quote {
      id
    }
  }
}
    `;
export type DeleteQuoteMutationFn = ApolloReactCommon.MutationFunction<DeleteQuoteMutation, DeleteQuoteMutationVariables>;
export type DeleteQuoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>, 'mutation'>;

    export const DeleteQuoteComponent = (props: DeleteQuoteComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteQuoteMutation, DeleteQuoteMutationVariables> mutation={DeleteQuoteDocument} {...props} />
    );
    
export type DeleteQuoteProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeleteQuoteMutation, DeleteQuoteMutationVariables> | TChildProps;
export function withDeleteQuote<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteQuoteMutation,
  DeleteQuoteMutationVariables,
  DeleteQuoteProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteQuoteMutation, DeleteQuoteMutationVariables, DeleteQuoteProps<TChildProps>>(DeleteQuoteDocument, {
      alias: 'deleteQuote',
      ...operationOptions
    });
};

/**
 * __useDeleteQuoteMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteMutation, { data, loading, error }] = useDeleteQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteQuoteMutation, DeleteQuoteMutationVariables>(DeleteQuoteDocument, baseOptions);
      }
export type DeleteQuoteMutationHookResult = ReturnType<typeof useDeleteQuoteMutation>;
export type DeleteQuoteMutationResult = ApolloReactCommon.MutationResult<DeleteQuoteMutation>;
export type DeleteQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>;
export const UpdateCiInformationDocument = gql`
    mutation updateCiInformation($id: ID!, $input: editCiInformationInput) {
  updateCiInformation(input: {where: {id: $id}, data: $input}) {
    ciInformation {
      id
      ciName
      serialNum
      ciLocation
    }
  }
}
    `;
export type UpdateCiInformationMutationFn = ApolloReactCommon.MutationFunction<UpdateCiInformationMutation, UpdateCiInformationMutationVariables>;
export type UpdateCiInformationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCiInformationMutation, UpdateCiInformationMutationVariables>, 'mutation'>;

    export const UpdateCiInformationComponent = (props: UpdateCiInformationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCiInformationMutation, UpdateCiInformationMutationVariables> mutation={UpdateCiInformationDocument} {...props} />
    );
    
export type UpdateCiInformationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateCiInformationMutation, UpdateCiInformationMutationVariables> | TChildProps;
export function withUpdateCiInformation<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCiInformationMutation,
  UpdateCiInformationMutationVariables,
  UpdateCiInformationProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCiInformationMutation, UpdateCiInformationMutationVariables, UpdateCiInformationProps<TChildProps>>(UpdateCiInformationDocument, {
      alias: 'updateCiInformation',
      ...operationOptions
    });
};

/**
 * __useUpdateCiInformationMutation__
 *
 * To run a mutation, you first call `useUpdateCiInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCiInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCiInformationMutation, { data, loading, error }] = useUpdateCiInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCiInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCiInformationMutation, UpdateCiInformationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCiInformationMutation, UpdateCiInformationMutationVariables>(UpdateCiInformationDocument, baseOptions);
      }
export type UpdateCiInformationMutationHookResult = ReturnType<typeof useUpdateCiInformationMutation>;
export type UpdateCiInformationMutationResult = ApolloReactCommon.MutationResult<UpdateCiInformationMutation>;
export type UpdateCiInformationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCiInformationMutation, UpdateCiInformationMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation updateNotification($id: ID!, $input: editNotificationInput) {
  updateNotification(input: {where: {id: $id}, data: $input}) {
    notification {
      id
      read
      title
      description
      ticket {
        id
        summary
        status {
          name
        }
        ticketSummary
        warranty
        location {
          address
        }
      }
      client {
        id
        name
        vatNumber
      }
      created_at
      updated_at
    }
  }
}
    `;
export type UpdateNotificationMutationFn = ApolloReactCommon.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export type UpdateNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>, 'mutation'>;

    export const UpdateNotificationComponent = (props: UpdateNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateNotificationMutation, UpdateNotificationMutationVariables> mutation={UpdateNotificationDocument} {...props} />
    );
    
export type UpdateNotificationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateNotificationMutation, UpdateNotificationMutationVariables> | TChildProps;
export function withUpdateNotification<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateNotificationMutation,
  UpdateNotificationMutationVariables,
  UpdateNotificationProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateNotificationMutation, UpdateNotificationMutationVariables, UpdateNotificationProps<TChildProps>>(UpdateNotificationDocument, {
      alias: 'updateNotification',
      ...operationOptions
    });
};

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, baseOptions);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = ApolloReactCommon.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const UpdateQuoteDocument = gql`
    mutation updateQuote($id: ID!, $input: editQuoteInput) {
  updateQuote(input: {where: {id: $id}, data: $input}) {
    quote {
      id
      contractor {
        username
        email
        contractorName
        client {
          name
        }
      }
      expiryDate
      status
      termsAndConditions
      ticket {
        id
      }
      items {
        item {
          id
          name
          description
          recommendedUnitPrice
        }
        id
        unitPrice
        quantity
        totalPrice
        description
        itemType {
          id
          name
          description
        }
      }
      documents {
        id
        name
        file {
          url
        }
      }
    }
  }
}
    `;
export type UpdateQuoteMutationFn = ApolloReactCommon.MutationFunction<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export type UpdateQuoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>, 'mutation'>;

    export const UpdateQuoteComponent = (props: UpdateQuoteComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateQuoteMutation, UpdateQuoteMutationVariables> mutation={UpdateQuoteDocument} {...props} />
    );
    
export type UpdateQuoteProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateQuoteMutation, UpdateQuoteMutationVariables> | TChildProps;
export function withUpdateQuote<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateQuoteMutation,
  UpdateQuoteMutationVariables,
  UpdateQuoteProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateQuoteMutation, UpdateQuoteMutationVariables, UpdateQuoteProps<TChildProps>>(UpdateQuoteDocument, {
      alias: 'updateQuote',
      ...operationOptions
    });
};

/**
 * __useUpdateQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteMutation, { data, loading, error }] = useUpdateQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateQuoteMutation, UpdateQuoteMutationVariables>(UpdateQuoteDocument, baseOptions);
      }
export type UpdateQuoteMutationHookResult = ReturnType<typeof useUpdateQuoteMutation>;
export type UpdateQuoteMutationResult = ApolloReactCommon.MutationResult<UpdateQuoteMutation>;
export type UpdateQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export const UpdateTicketDocument = gql`
    mutation updateTicket($id: ID!, $input: editTicketInput) {
  updateTicket(input: {where: {id: $id}, data: $input}) {
    ticket {
      id
      ticketNumber
      location {
        id
        name
        address
        enabled
        googleMaps
      }
      summary
      status {
        id
        name
        enabled
        content
      }
      warranty
      client {
        id
        name
        tickets {
          id
        }
      }
      ticketSummary
      quoteAmount
      warrantyStartDate
      warrantyEndDate
      created_at
      updated_at
      documents {
        id
        name
        file {
          url
        }
      }
      messages {
        id
        title
        description
        ticket {
          id
        }
        updated_at
      }
      vendor {
        id
        vendorRef
        dispatchDate
        expectedArrival
        actualArrival
      }
      ci {
        id
        ciName
        serialNum
        ciLocation
      }
      actualFault {
        id
      }
      resolutionCode {
        id
      }
      subFault {
        id
      }
    }
  }
}
    `;
export type UpdateTicketMutationFn = ApolloReactCommon.MutationFunction<UpdateTicketMutation, UpdateTicketMutationVariables>;
export type UpdateTicketComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateTicketMutation, UpdateTicketMutationVariables>, 'mutation'>;

    export const UpdateTicketComponent = (props: UpdateTicketComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateTicketMutation, UpdateTicketMutationVariables> mutation={UpdateTicketDocument} {...props} />
    );
    
export type UpdateTicketProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateTicketMutation, UpdateTicketMutationVariables> | TChildProps;
export function withUpdateTicket<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateTicketMutation,
  UpdateTicketMutationVariables,
  UpdateTicketProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateTicketMutation, UpdateTicketMutationVariables, UpdateTicketProps<TChildProps>>(UpdateTicketDocument, {
      alias: 'updateTicket',
      ...operationOptions
    });
};

/**
 * __useUpdateTicketMutation__
 *
 * To run a mutation, you first call `useUpdateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketMutation, { data, loading, error }] = useUpdateTicketMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTicketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTicketMutation, UpdateTicketMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTicketMutation, UpdateTicketMutationVariables>(UpdateTicketDocument, baseOptions);
      }
export type UpdateTicketMutationHookResult = ReturnType<typeof useUpdateTicketMutation>;
export type UpdateTicketMutationResult = ApolloReactCommon.MutationResult<UpdateTicketMutation>;
export type UpdateTicketMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTicketMutation, UpdateTicketMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $input: editUserInput) {
  updateUser(input: {where: {id: $id}, data: $input}) {
    user {
      id
      username
      email
      confirmed
      password
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;
export type UpdateUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserMutation, UpdateUserMutationVariables>, 'mutation'>;

    export const UpdateUserComponent = (props: UpdateUserComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserMutation, UpdateUserMutationVariables> mutation={UpdateUserDocument} {...props} />
    );
    
export type UpdateUserProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateUserMutation, UpdateUserMutationVariables> | TChildProps;
export function withUpdateUser<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserMutation,
  UpdateUserMutationVariables,
  UpdateUserProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserMutation, UpdateUserMutationVariables, UpdateUserProps<TChildProps>>(UpdateUserDocument, {
      alias: 'updateUser',
      ...operationOptions
    });
};

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateVendorInformationDocument = gql`
    mutation updateVendorInformation($id: ID!, $input: editVendorInformationInput) {
  updateVendorInformation(input: {where: {id: $id}, data: $input}) {
    vendorInformation {
      id
      vendorRef
      dispatchDate
      expectedArrival
      actualArrival
    }
  }
}
    `;
export type UpdateVendorInformationMutationFn = ApolloReactCommon.MutationFunction<UpdateVendorInformationMutation, UpdateVendorInformationMutationVariables>;
export type UpdateVendorInformationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateVendorInformationMutation, UpdateVendorInformationMutationVariables>, 'mutation'>;

    export const UpdateVendorInformationComponent = (props: UpdateVendorInformationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateVendorInformationMutation, UpdateVendorInformationMutationVariables> mutation={UpdateVendorInformationDocument} {...props} />
    );
    
export type UpdateVendorInformationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateVendorInformationMutation, UpdateVendorInformationMutationVariables> | TChildProps;
export function withUpdateVendorInformation<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateVendorInformationMutation,
  UpdateVendorInformationMutationVariables,
  UpdateVendorInformationProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateVendorInformationMutation, UpdateVendorInformationMutationVariables, UpdateVendorInformationProps<TChildProps>>(UpdateVendorInformationDocument, {
      alias: 'updateVendorInformation',
      ...operationOptions
    });
};

/**
 * __useUpdateVendorInformationMutation__
 *
 * To run a mutation, you first call `useUpdateVendorInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorInformationMutation, { data, loading, error }] = useUpdateVendorInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVendorInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVendorInformationMutation, UpdateVendorInformationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateVendorInformationMutation, UpdateVendorInformationMutationVariables>(UpdateVendorInformationDocument, baseOptions);
      }
export type UpdateVendorInformationMutationHookResult = ReturnType<typeof useUpdateVendorInformationMutation>;
export type UpdateVendorInformationMutationResult = ApolloReactCommon.MutationResult<UpdateVendorInformationMutation>;
export type UpdateVendorInformationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateVendorInformationMutation, UpdateVendorInformationMutationVariables>;
export const GetActualFaultsDocument = gql`
    query getActualFaults {
  actualFaults {
    id
    fault
  }
}
    `;
export type GetActualFaultsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetActualFaultsQuery, GetActualFaultsQueryVariables>, 'query'>;

    export const GetActualFaultsComponent = (props: GetActualFaultsComponentProps) => (
      <ApolloReactComponents.Query<GetActualFaultsQuery, GetActualFaultsQueryVariables> query={GetActualFaultsDocument} {...props} />
    );
    
export type GetActualFaultsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetActualFaultsQuery, GetActualFaultsQueryVariables> | TChildProps;
export function withGetActualFaults<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetActualFaultsQuery,
  GetActualFaultsQueryVariables,
  GetActualFaultsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetActualFaultsQuery, GetActualFaultsQueryVariables, GetActualFaultsProps<TChildProps>>(GetActualFaultsDocument, {
      alias: 'getActualFaults',
      ...operationOptions
    });
};

/**
 * __useGetActualFaultsQuery__
 *
 * To run a query within a React component, call `useGetActualFaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActualFaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActualFaultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActualFaultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetActualFaultsQuery, GetActualFaultsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetActualFaultsQuery, GetActualFaultsQueryVariables>(GetActualFaultsDocument, baseOptions);
      }
export function useGetActualFaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActualFaultsQuery, GetActualFaultsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetActualFaultsQuery, GetActualFaultsQueryVariables>(GetActualFaultsDocument, baseOptions);
        }
export type GetActualFaultsQueryHookResult = ReturnType<typeof useGetActualFaultsQuery>;
export type GetActualFaultsLazyQueryHookResult = ReturnType<typeof useGetActualFaultsLazyQuery>;
export type GetActualFaultsQueryResult = ApolloReactCommon.QueryResult<GetActualFaultsQuery, GetActualFaultsQueryVariables>;
export const GetConfigurationDocument = gql`
    query getConfiguration {
  configurations(sort: "created_at:DESC", limit: 1) {
    showWarranty
    showQuoteBuilder
    showDocuments
    showVendorInfo
    showCiInfo
    showClosingInfo
    created_at
  }
}
    `;
export type GetConfigurationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetConfigurationQuery, GetConfigurationQueryVariables>, 'query'>;

    export const GetConfigurationComponent = (props: GetConfigurationComponentProps) => (
      <ApolloReactComponents.Query<GetConfigurationQuery, GetConfigurationQueryVariables> query={GetConfigurationDocument} {...props} />
    );
    
export type GetConfigurationProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetConfigurationQuery, GetConfigurationQueryVariables> | TChildProps;
export function withGetConfiguration<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetConfigurationQuery,
  GetConfigurationQueryVariables,
  GetConfigurationProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetConfigurationQuery, GetConfigurationQueryVariables, GetConfigurationProps<TChildProps>>(GetConfigurationDocument, {
      alias: 'getConfiguration',
      ...operationOptions
    });
};

/**
 * __useGetConfigurationQuery__
 *
 * To run a query within a React component, call `useGetConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigurationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, baseOptions);
      }
export function useGetConfigurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, baseOptions);
        }
export type GetConfigurationQueryHookResult = ReturnType<typeof useGetConfigurationQuery>;
export type GetConfigurationLazyQueryHookResult = ReturnType<typeof useGetConfigurationLazyQuery>;
export type GetConfigurationQueryResult = ApolloReactCommon.QueryResult<GetConfigurationQuery, GetConfigurationQueryVariables>;
export const GetItemTypesDocument = gql`
    query getItemTypes {
  itemTypes(where: {enabled: true}) {
    id
    name
    description
  }
}
    `;
export type GetItemTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetItemTypesQuery, GetItemTypesQueryVariables>, 'query'>;

    export const GetItemTypesComponent = (props: GetItemTypesComponentProps) => (
      <ApolloReactComponents.Query<GetItemTypesQuery, GetItemTypesQueryVariables> query={GetItemTypesDocument} {...props} />
    );
    
export type GetItemTypesProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetItemTypesQuery, GetItemTypesQueryVariables> | TChildProps;
export function withGetItemTypes<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetItemTypesQuery,
  GetItemTypesQueryVariables,
  GetItemTypesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetItemTypesQuery, GetItemTypesQueryVariables, GetItemTypesProps<TChildProps>>(GetItemTypesDocument, {
      alias: 'getItemTypes',
      ...operationOptions
    });
};

/**
 * __useGetItemTypesQuery__
 *
 * To run a query within a React component, call `useGetItemTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetItemTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetItemTypesQuery, GetItemTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetItemTypesQuery, GetItemTypesQueryVariables>(GetItemTypesDocument, baseOptions);
      }
export function useGetItemTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetItemTypesQuery, GetItemTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetItemTypesQuery, GetItemTypesQueryVariables>(GetItemTypesDocument, baseOptions);
        }
export type GetItemTypesQueryHookResult = ReturnType<typeof useGetItemTypesQuery>;
export type GetItemTypesLazyQueryHookResult = ReturnType<typeof useGetItemTypesLazyQuery>;
export type GetItemTypesQueryResult = ApolloReactCommon.QueryResult<GetItemTypesQuery, GetItemTypesQueryVariables>;
export const GetItemsDocument = gql`
    query getItems {
  items(where: {enabled: true}) {
    id
    name
    description
    recommendedUnitPrice
  }
}
    `;
export type GetItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetItemsQuery, GetItemsQueryVariables>, 'query'>;

    export const GetItemsComponent = (props: GetItemsComponentProps) => (
      <ApolloReactComponents.Query<GetItemsQuery, GetItemsQueryVariables> query={GetItemsDocument} {...props} />
    );
    
export type GetItemsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetItemsQuery, GetItemsQueryVariables> | TChildProps;
export function withGetItems<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetItemsQuery,
  GetItemsQueryVariables,
  GetItemsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetItemsQuery, GetItemsQueryVariables, GetItemsProps<TChildProps>>(GetItemsDocument, {
      alias: 'getItems',
      ...operationOptions
    });
};

/**
 * __useGetItemsQuery__
 *
 * To run a query within a React component, call `useGetItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetItemsQuery, GetItemsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetItemsQuery, GetItemsQueryVariables>(GetItemsDocument, baseOptions);
      }
export function useGetItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetItemsQuery, GetItemsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetItemsQuery, GetItemsQueryVariables>(GetItemsDocument, baseOptions);
        }
export type GetItemsQueryHookResult = ReturnType<typeof useGetItemsQuery>;
export type GetItemsLazyQueryHookResult = ReturnType<typeof useGetItemsLazyQuery>;
export type GetItemsQueryResult = ApolloReactCommon.QueryResult<GetItemsQuery, GetItemsQueryVariables>;
export const GetMessageDocument = gql`
    query getMessage($ticketId: ID!, $messageId: ID!) {
  messages(where: {ticket: $ticketId, id: $messageId}) {
    id
    title
    description
    ticket {
      id
      ticketNumber
    }
    created_at
    updated_at
  }
}
    `;
export type GetMessageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMessageQuery, GetMessageQueryVariables>, 'query'> & ({ variables: GetMessageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMessageComponent = (props: GetMessageComponentProps) => (
      <ApolloReactComponents.Query<GetMessageQuery, GetMessageQueryVariables> query={GetMessageDocument} {...props} />
    );
    
export type GetMessageProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetMessageQuery, GetMessageQueryVariables> | TChildProps;
export function withGetMessage<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMessageQuery,
  GetMessageQueryVariables,
  GetMessageProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetMessageQuery, GetMessageQueryVariables, GetMessageProps<TChildProps>>(GetMessageDocument, {
      alias: 'getMessage',
      ...operationOptions
    });
};

/**
 * __useGetMessageQuery__
 *
 * To run a query within a React component, call `useGetMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useGetMessageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, baseOptions);
      }
export function useGetMessageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, baseOptions);
        }
export type GetMessageQueryHookResult = ReturnType<typeof useGetMessageQuery>;
export type GetMessageLazyQueryHookResult = ReturnType<typeof useGetMessageLazyQuery>;
export type GetMessageQueryResult = ApolloReactCommon.QueryResult<GetMessageQuery, GetMessageQueryVariables>;
export const GetMessagesDocument = gql`
    query getMessages($ticketId: ID!) {
  messages(where: {ticket: $ticketId}) {
    id
    title
    description
    ticket {
      id
      ticketNumber
    }
    created_at
    updated_at
  }
}
    `;
export type GetMessagesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMessagesQuery, GetMessagesQueryVariables>, 'query'> & ({ variables: GetMessagesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMessagesComponent = (props: GetMessagesComponentProps) => (
      <ApolloReactComponents.Query<GetMessagesQuery, GetMessagesQueryVariables> query={GetMessagesDocument} {...props} />
    );
    
export type GetMessagesProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetMessagesQuery, GetMessagesQueryVariables> | TChildProps;
export function withGetMessages<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMessagesQuery,
  GetMessagesQueryVariables,
  GetMessagesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetMessagesQuery, GetMessagesQueryVariables, GetMessagesProps<TChildProps>>(GetMessagesDocument, {
      alias: 'getMessages',
      ...operationOptions
    });
};

/**
 * __useGetMessagesQuery__
 *
 * To run a query within a React component, call `useGetMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetMessagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, baseOptions);
      }
export function useGetMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, baseOptions);
        }
export type GetMessagesQueryHookResult = ReturnType<typeof useGetMessagesQuery>;
export type GetMessagesLazyQueryHookResult = ReturnType<typeof useGetMessagesLazyQuery>;
export type GetMessagesQueryResult = ApolloReactCommon.QueryResult<GetMessagesQuery, GetMessagesQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($clientId: ID!) {
  notifications(where: {client: $clientId, read: false}) {
    id
    title
    description
    ticket {
      id
      summary
      status {
        name
      }
      ticketSummary
      ticketNumber
      warranty
      location {
        address
      }
    }
    client {
      id
      name
      vatNumber
    }
    created_at
    updated_at
  }
}
    `;
export type GetNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNotificationsQuery, GetNotificationsQueryVariables>, 'query'> & ({ variables: GetNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNotificationsComponent = (props: GetNotificationsComponentProps) => (
      <ApolloReactComponents.Query<GetNotificationsQuery, GetNotificationsQueryVariables> query={GetNotificationsDocument} {...props} />
    );
    
export type GetNotificationsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetNotificationsQuery, GetNotificationsQueryVariables> | TChildProps;
export function withGetNotifications<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNotificationsQuery,
  GetNotificationsQueryVariables,
  GetNotificationsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetNotificationsQuery, GetNotificationsQueryVariables, GetNotificationsProps<TChildProps>>(GetNotificationsDocument, {
      alias: 'getNotifications',
      ...operationOptions
    });
};

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, baseOptions);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, baseOptions);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = ApolloReactCommon.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetQuoteDocument = gql`
    query getQuote($quoteId: ID!) {
  quote(id: $quoteId) {
    id
    contractor {
      username
      email
      confirmed
      client {
        name
        vatNumber
      }
      quotes {
        id
      }
      quotes {
        id
      }
      contractorName
    }
    expiryDate
    status
    termsAndConditions
    ticket {
      id
    }
    items {
      item {
        id
        name
        description
        recommendedUnitPrice
      }
      id
      unitPrice
      quantity
      totalPrice
      description
      itemType {
        id
        name
        description
      }
    }
    documents {
      id
      name
      file {
        url
      }
    }
    created_at
    updated_at
  }
}
    `;
export type GetQuoteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetQuoteQuery, GetQuoteQueryVariables>, 'query'> & ({ variables: GetQuoteQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetQuoteComponent = (props: GetQuoteComponentProps) => (
      <ApolloReactComponents.Query<GetQuoteQuery, GetQuoteQueryVariables> query={GetQuoteDocument} {...props} />
    );
    
export type GetQuoteProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetQuoteQuery, GetQuoteQueryVariables> | TChildProps;
export function withGetQuote<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetQuoteQuery,
  GetQuoteQueryVariables,
  GetQuoteProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetQuoteQuery, GetQuoteQueryVariables, GetQuoteProps<TChildProps>>(GetQuoteDocument, {
      alias: 'getQuote',
      ...operationOptions
    });
};

/**
 * __useGetQuoteQuery__
 *
 * To run a query within a React component, call `useGetQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetQuoteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables>) {
        return ApolloReactHooks.useQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, baseOptions);
      }
export function useGetQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, baseOptions);
        }
export type GetQuoteQueryHookResult = ReturnType<typeof useGetQuoteQuery>;
export type GetQuoteLazyQueryHookResult = ReturnType<typeof useGetQuoteLazyQuery>;
export type GetQuoteQueryResult = ApolloReactCommon.QueryResult<GetQuoteQuery, GetQuoteQueryVariables>;
export const GetQuotesDocument = gql`
    query getQuotes($ticketId: ID!) {
  quotes(where: {ticket: $ticketId}) {
    id
    contractor {
      username
      email
      confirmed
      client {
        name
        vatNumber
      }
      quotes {
        id
      }
      quotes {
        id
      }
      contractorName
    }
    expiryDate
    status
    termsAndConditions
    ticket {
      id
    }
    items {
      item {
        id
        name
        description
        recommendedUnitPrice
      }
      id
      unitPrice
      quantity
      totalPrice
      description
    }
    documents {
      id
      name
      file {
        url
      }
    }
    created_at
    updated_at
  }
}
    `;
export type GetQuotesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetQuotesQuery, GetQuotesQueryVariables>, 'query'> & ({ variables: GetQuotesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetQuotesComponent = (props: GetQuotesComponentProps) => (
      <ApolloReactComponents.Query<GetQuotesQuery, GetQuotesQueryVariables> query={GetQuotesDocument} {...props} />
    );
    
export type GetQuotesProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetQuotesQuery, GetQuotesQueryVariables> | TChildProps;
export function withGetQuotes<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetQuotesQuery,
  GetQuotesQueryVariables,
  GetQuotesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetQuotesQuery, GetQuotesQueryVariables, GetQuotesProps<TChildProps>>(GetQuotesDocument, {
      alias: 'getQuotes',
      ...operationOptions
    });
};

/**
 * __useGetQuotesQuery__
 *
 * To run a query within a React component, call `useGetQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetQuotesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, baseOptions);
      }
export function useGetQuotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, baseOptions);
        }
export type GetQuotesQueryHookResult = ReturnType<typeof useGetQuotesQuery>;
export type GetQuotesLazyQueryHookResult = ReturnType<typeof useGetQuotesLazyQuery>;
export type GetQuotesQueryResult = ApolloReactCommon.QueryResult<GetQuotesQuery, GetQuotesQueryVariables>;
export const GetResolutionCodesDocument = gql`
    query getResolutionCodes {
  resolutionCodes {
    id
    resCode
  }
}
    `;
export type GetResolutionCodesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetResolutionCodesQuery, GetResolutionCodesQueryVariables>, 'query'>;

    export const GetResolutionCodesComponent = (props: GetResolutionCodesComponentProps) => (
      <ApolloReactComponents.Query<GetResolutionCodesQuery, GetResolutionCodesQueryVariables> query={GetResolutionCodesDocument} {...props} />
    );
    
export type GetResolutionCodesProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetResolutionCodesQuery, GetResolutionCodesQueryVariables> | TChildProps;
export function withGetResolutionCodes<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetResolutionCodesQuery,
  GetResolutionCodesQueryVariables,
  GetResolutionCodesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetResolutionCodesQuery, GetResolutionCodesQueryVariables, GetResolutionCodesProps<TChildProps>>(GetResolutionCodesDocument, {
      alias: 'getResolutionCodes',
      ...operationOptions
    });
};

/**
 * __useGetResolutionCodesQuery__
 *
 * To run a query within a React component, call `useGetResolutionCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolutionCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolutionCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResolutionCodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetResolutionCodesQuery, GetResolutionCodesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetResolutionCodesQuery, GetResolutionCodesQueryVariables>(GetResolutionCodesDocument, baseOptions);
      }
export function useGetResolutionCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetResolutionCodesQuery, GetResolutionCodesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetResolutionCodesQuery, GetResolutionCodesQueryVariables>(GetResolutionCodesDocument, baseOptions);
        }
export type GetResolutionCodesQueryHookResult = ReturnType<typeof useGetResolutionCodesQuery>;
export type GetResolutionCodesLazyQueryHookResult = ReturnType<typeof useGetResolutionCodesLazyQuery>;
export type GetResolutionCodesQueryResult = ApolloReactCommon.QueryResult<GetResolutionCodesQuery, GetResolutionCodesQueryVariables>;
export const GetStatusesDocument = gql`
    query getStatuses {
  statuses {
    id
    name
    content
    uploadRequired
    enabled
  }
}
    `;
export type GetStatusesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetStatusesQuery, GetStatusesQueryVariables>, 'query'>;

    export const GetStatusesComponent = (props: GetStatusesComponentProps) => (
      <ApolloReactComponents.Query<GetStatusesQuery, GetStatusesQueryVariables> query={GetStatusesDocument} {...props} />
    );
    
export type GetStatusesProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetStatusesQuery, GetStatusesQueryVariables> | TChildProps;
export function withGetStatuses<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetStatusesQuery,
  GetStatusesQueryVariables,
  GetStatusesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetStatusesQuery, GetStatusesQueryVariables, GetStatusesProps<TChildProps>>(GetStatusesDocument, {
      alias: 'getStatuses',
      ...operationOptions
    });
};

/**
 * __useGetStatusesQuery__
 *
 * To run a query within a React component, call `useGetStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatusesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStatusesQuery, GetStatusesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStatusesQuery, GetStatusesQueryVariables>(GetStatusesDocument, baseOptions);
      }
export function useGetStatusesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStatusesQuery, GetStatusesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStatusesQuery, GetStatusesQueryVariables>(GetStatusesDocument, baseOptions);
        }
export type GetStatusesQueryHookResult = ReturnType<typeof useGetStatusesQuery>;
export type GetStatusesLazyQueryHookResult = ReturnType<typeof useGetStatusesLazyQuery>;
export type GetStatusesQueryResult = ApolloReactCommon.QueryResult<GetStatusesQuery, GetStatusesQueryVariables>;
export const GetSubFaultsDocument = gql`
    query getSubFaults {
  subFaults {
    id
    subFault
  }
}
    `;
export type GetSubFaultsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubFaultsQuery, GetSubFaultsQueryVariables>, 'query'>;

    export const GetSubFaultsComponent = (props: GetSubFaultsComponentProps) => (
      <ApolloReactComponents.Query<GetSubFaultsQuery, GetSubFaultsQueryVariables> query={GetSubFaultsDocument} {...props} />
    );
    
export type GetSubFaultsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetSubFaultsQuery, GetSubFaultsQueryVariables> | TChildProps;
export function withGetSubFaults<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubFaultsQuery,
  GetSubFaultsQueryVariables,
  GetSubFaultsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubFaultsQuery, GetSubFaultsQueryVariables, GetSubFaultsProps<TChildProps>>(GetSubFaultsDocument, {
      alias: 'getSubFaults',
      ...operationOptions
    });
};

/**
 * __useGetSubFaultsQuery__
 *
 * To run a query within a React component, call `useGetSubFaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubFaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubFaultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubFaultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubFaultsQuery, GetSubFaultsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubFaultsQuery, GetSubFaultsQueryVariables>(GetSubFaultsDocument, baseOptions);
      }
export function useGetSubFaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubFaultsQuery, GetSubFaultsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubFaultsQuery, GetSubFaultsQueryVariables>(GetSubFaultsDocument, baseOptions);
        }
export type GetSubFaultsQueryHookResult = ReturnType<typeof useGetSubFaultsQuery>;
export type GetSubFaultsLazyQueryHookResult = ReturnType<typeof useGetSubFaultsLazyQuery>;
export type GetSubFaultsQueryResult = ApolloReactCommon.QueryResult<GetSubFaultsQuery, GetSubFaultsQueryVariables>;
export const GetTicketDocument = gql`
    query getTicket($ticketId: ID!) {
  ticket(id: $ticketId) {
    id
    ticketNumber
    requestedBy
    location {
      id
      name
      address
      enabled
      googleMaps
    }
    summary
    status {
      id
      name
      enabled
      content
      complete
      uploadRequired
    }
    warranty
    client {
      id
      name
      tickets {
        id
      }
    }
    ticketSummary
    ticketSlaPriority
    warrantyStartDate
    warrantyEndDate
    quoteAmount
    created_at
    updated_at
    messages {
      id
      title
      description
      ticket {
        id
      }
      created_at
      updated_at
    }
    documents {
      id
      name
      file {
        url
      }
      created_at
    }
    vendor {
      id
      vendorRef
      dispatchDate
      expectedArrival
      actualArrival
    }
    ci {
      id
      ciName
      serialNum
      ciLocation
    }
    resolutionCode {
      id
      resCode
    }
    actualFault {
      id
      fault
    }
    subFault {
      id
      subFault
    }
  }
}
    `;
export type GetTicketComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTicketQuery, GetTicketQueryVariables>, 'query'> & ({ variables: GetTicketQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetTicketComponent = (props: GetTicketComponentProps) => (
      <ApolloReactComponents.Query<GetTicketQuery, GetTicketQueryVariables> query={GetTicketDocument} {...props} />
    );
    
export type GetTicketProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetTicketQuery, GetTicketQueryVariables> | TChildProps;
export function withGetTicket<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTicketQuery,
  GetTicketQueryVariables,
  GetTicketProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetTicketQuery, GetTicketQueryVariables, GetTicketProps<TChildProps>>(GetTicketDocument, {
      alias: 'getTicket',
      ...operationOptions
    });
};

/**
 * __useGetTicketQuery__
 *
 * To run a query within a React component, call `useGetTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetTicketQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTicketQuery, GetTicketQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTicketQuery, GetTicketQueryVariables>(GetTicketDocument, baseOptions);
      }
export function useGetTicketLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTicketQuery, GetTicketQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTicketQuery, GetTicketQueryVariables>(GetTicketDocument, baseOptions);
        }
export type GetTicketQueryHookResult = ReturnType<typeof useGetTicketQuery>;
export type GetTicketLazyQueryHookResult = ReturnType<typeof useGetTicketLazyQuery>;
export type GetTicketQueryResult = ApolloReactCommon.QueryResult<GetTicketQuery, GetTicketQueryVariables>;
export const GetTicketsDocument = gql`
    query getTickets($filter: JSON, $start: Int, $limit: Int) {
  tickets(where: $filter, start: $start, limit: $limit, sort: "created_at:desc") {
    id
    ticketNumber
    requestedBy
    location {
      id
      name
      address
      enabled
      googleMaps
    }
    summary
    status {
      id
      name
      enabled
      content
      complete
    }
    warranty
    client {
      id
      name
      tickets {
        id
      }
    }
    ticketSummary
    ticketSlaPriority
    warrantyStartDate
    warrantyEndDate
    quoteAmount
    created_at
    updated_at
    messages {
      id
      title
      description
      ticket {
        id
      }
      created_at
      updated_at
    }
    documents {
      name
      file {
        url
      }
    }
  }
}
    `;
export type GetTicketsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTicketsQuery, GetTicketsQueryVariables>, 'query'>;

    export const GetTicketsComponent = (props: GetTicketsComponentProps) => (
      <ApolloReactComponents.Query<GetTicketsQuery, GetTicketsQueryVariables> query={GetTicketsDocument} {...props} />
    );
    
export type GetTicketsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetTicketsQuery, GetTicketsQueryVariables> | TChildProps;
export function withGetTickets<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTicketsQuery,
  GetTicketsQueryVariables,
  GetTicketsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetTicketsQuery, GetTicketsQueryVariables, GetTicketsProps<TChildProps>>(GetTicketsDocument, {
      alias: 'getTickets',
      ...operationOptions
    });
};

/**
 * __useGetTicketsQuery__
 *
 * To run a query within a React component, call `useGetTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTicketsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTicketsQuery, GetTicketsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTicketsQuery, GetTicketsQueryVariables>(GetTicketsDocument, baseOptions);
      }
export function useGetTicketsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTicketsQuery, GetTicketsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTicketsQuery, GetTicketsQueryVariables>(GetTicketsDocument, baseOptions);
        }
export type GetTicketsQueryHookResult = ReturnType<typeof useGetTicketsQuery>;
export type GetTicketsLazyQueryHookResult = ReturnType<typeof useGetTicketsLazyQuery>;
export type GetTicketsQueryResult = ApolloReactCommon.QueryResult<GetTicketsQuery, GetTicketsQueryVariables>;
export const GetTicketsCountDocument = gql`
    query getTicketsCount($filter: JSON) {
  tickets(where: $filter) {
    id
  }
}
    `;
export type GetTicketsCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTicketsCountQuery, GetTicketsCountQueryVariables>, 'query'>;

    export const GetTicketsCountComponent = (props: GetTicketsCountComponentProps) => (
      <ApolloReactComponents.Query<GetTicketsCountQuery, GetTicketsCountQueryVariables> query={GetTicketsCountDocument} {...props} />
    );
    
export type GetTicketsCountProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetTicketsCountQuery, GetTicketsCountQueryVariables> | TChildProps;
export function withGetTicketsCount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTicketsCountQuery,
  GetTicketsCountQueryVariables,
  GetTicketsCountProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetTicketsCountQuery, GetTicketsCountQueryVariables, GetTicketsCountProps<TChildProps>>(GetTicketsCountDocument, {
      alias: 'getTicketsCount',
      ...operationOptions
    });
};

/**
 * __useGetTicketsCountQuery__
 *
 * To run a query within a React component, call `useGetTicketsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTicketsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTicketsCountQuery, GetTicketsCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTicketsCountQuery, GetTicketsCountQueryVariables>(GetTicketsCountDocument, baseOptions);
      }
export function useGetTicketsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTicketsCountQuery, GetTicketsCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTicketsCountQuery, GetTicketsCountQueryVariables>(GetTicketsCountDocument, baseOptions);
        }
export type GetTicketsCountQueryHookResult = ReturnType<typeof useGetTicketsCountQuery>;
export type GetTicketsCountLazyQueryHookResult = ReturnType<typeof useGetTicketsCountLazyQuery>;
export type GetTicketsCountQueryResult = ApolloReactCommon.QueryResult<GetTicketsCountQuery, GetTicketsCountQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: ID!) {
  user(id: $id) {
    id
    username
    email
    confirmed
    blocked
    role {
      id
      name
      description
      type
    }
    client {
      id
      name
      vatNumber
    }
  }
}
    `;
export type GetUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserQuery, GetUserQueryVariables>, 'query'> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserComponent = (props: GetUserComponentProps) => (
      <ApolloReactComponents.Query<GetUserQuery, GetUserQueryVariables> query={GetUserDocument} {...props} />
    );
    
export type GetUserProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetUserQuery, GetUserQueryVariables> | TChildProps;
export function withGetUser<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserQuery,
  GetUserQueryVariables,
  GetUserProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserQuery, GetUserQueryVariables, GetUserProps<TChildProps>>(GetUserDocument, {
      alias: 'getUser',
      ...operationOptions
    });
};

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = ApolloReactCommon.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const ListUsersDocument = gql`
    query ListUsers {
  users {
    id
    created_at
    updated_at
    username
    email
    provider
    confirmed
    blocked
    role {
      id
      name
      description
      type
    }
  }
}
    `;
export type ListUsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ListUsersQuery, ListUsersQueryVariables>, 'query'>;

    export const ListUsersComponent = (props: ListUsersComponentProps) => (
      <ApolloReactComponents.Query<ListUsersQuery, ListUsersQueryVariables> query={ListUsersDocument} {...props} />
    );
    
export type ListUsersProps<TChildProps = {}> = ApolloReactHoc.DataProps<ListUsersQuery, ListUsersQueryVariables> | TChildProps;
export function withListUsers<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ListUsersQuery,
  ListUsersQueryVariables,
  ListUsersProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, ListUsersQuery, ListUsersQueryVariables, ListUsersProps<TChildProps>>(ListUsersDocument, {
      alias: 'listUsers',
      ...operationOptions
    });
};

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        return ApolloReactHooks.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, baseOptions);
      }
export function useListUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, baseOptions);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = ApolloReactCommon.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    id
    username
    email
    confirmed
    blocked
    role {
      id
      name
      description
      type
    }
  }
}
    `;
export type GetMeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMeQuery, GetMeQueryVariables>, 'query'>;

    export const GetMeComponent = (props: GetMeComponentProps) => (
      <ApolloReactComponents.Query<GetMeQuery, GetMeQueryVariables> query={GetMeDocument} {...props} />
    );
    
export type GetMeProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetMeQuery, GetMeQueryVariables> | TChildProps;
export function withGetMe<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMeQuery,
  GetMeQueryVariables,
  GetMeProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetMeQuery, GetMeQueryVariables, GetMeProps<TChildProps>>(GetMeDocument, {
      alias: 'getMe',
      ...operationOptions
    });
};

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, baseOptions);
      }
export function useGetMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, baseOptions);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = ApolloReactCommon.QueryResult<GetMeQuery, GetMeQueryVariables>;